import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './BrandingIconCard.module.css';
import twitterIcon from '../../assets/images/twitter.png';

const GOOGLE = 'google';
const FACEBOOK = 'facebook';
const TIKTOK = 'tiktok';
const INSTAGRAM = 'instagram';
const SNAPCHAT = 'snapchat';
const TWITTER = 'twitter';
const PINTEREST = 'pinterest';
const PLUS = 'plus';
const MINUS = 'minus';
const UPLOAD = 'upload';
const SEARCH = 'search';
const LOCATION = 'location';
const DISLIKE = 'dislike';
const EMAIL = 'email';
const LOGO = 'logo';
const FOOTERINSTAGRAM = 'footerinstagram';
const FOOTERFACEBOOK = 'footerfacebook';
const FOOTERYOUTUBE = 'footeryoutube';
const CSV = 'csv';
const UNCHECK = 'uncheck';
const CHECKED = 'checked';
const YELLOWCHECK = 'yellowcheck';
const YELLOWUNCHECK = 'yellowuncheck';
const FILTER = 'filter';
const GRID = 'grid';
const DISCOUNT = 'general-discounts';
const BOGODEALS = 'bogo-deals';
const OFFER = 'bundle-offers';
const GIFT = 'freebies-and-gifts';
const REFERRAL = 'referral-discounts-parent';
const GROUPDISCOUNT = 'group-discounts-parent';
const CASHBACK = 'cashback-deals';
const PROMOS = 'promos';
const FREEDELIVERY = 'free-deliveries-parent';
const DOWNARROW = 'downarrow';
const UPARROW = 'uparrow';
const DEALS = 'deals';
const ACTIVE_ITEMS = 'active-items';
const ACTIVE_DEALS = 'active-deals';
const HEALTH = 'health';
const SOLD = 'sold';
const TRENDUP = 'trentup';
const TOTAL = 'total';
const BUZZ = 'buzz';
const SCANQR = 'scanqr';
const ACCEPTCODE = 'acceptcode';
const BUCKET = 'bucket';
const THREEDOT = 'threedot';
const RIGHTARROW = 'rightarrow';
const VIDEO = 'video';
const SETTING = 'setting';
const NOTIFICATION = 'notification';
const HEART = 'heart';
const STAR = 'star';
const EMPTYSTAR = 'star_2';
const EP = 'ep';
const WALLET = 'wallet';
const INSIGHT = 'insight';
const STAFF = 'staff';
const COMMERCIAL = 'commercial';
const HELPCENTER = 'helpcenter';
const SUPPORT = 'support';
const SETUP = 'setup';
const ABOUTNOW = 'aboutnow';
const TC = 'tc';
const PP = 'pp';
const EDIT = 'edit';
const DELETE = 'delete';
const HORIZONTALDOTS = 'horizantaldots';
const LIKE = 'like';
const UNLIKE = 'unlike';
const BLUELOGO = 'bluelogo';
const CART = 'cart';
const STAFFCHECK = 'staffcheck';
const BACKICON = "backicon";
const WHATSAPP = "whatsapp";
const LINKEDIN = "LINKEDIN";
const PEOPLE = "people";
const SHARE_LINK = "share-link"

const BrandingIconCard = props => {
  const { className, rootClassName, type } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (type) {
    case SHARE_LINK:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM17.25 12.33C17.25 12.74 16.91 13.08 16.5 13.08C16.09 13.08 15.75 12.74 15.75 12.33V9.31L8.03 17.03C7.88 17.18 7.69 17.25 7.5 17.25C7.31 17.25 7.12 17.18 6.97 17.03C6.68 16.74 6.68 16.26 6.97 15.97L14.69 8.25H11.67C11.26 8.25 10.92 7.91 10.92 7.5C10.92 7.09 11.26 6.75 11.67 6.75H16.5C16.91 6.75 17.25 7.09 17.25 7.5V12.33Z" fill="#007BFF" />
        </svg>
      );
    case PEOPLE:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5291 7.77C17.4591 7.76 17.3891 7.76 17.3191 7.77C15.7691 7.72 14.5391 6.45 14.5391 4.89C14.5391 3.3 15.8291 2 17.4291 2C19.0191 2 20.3191 3.29 20.3191 4.89C20.3091 6.45 19.0791 7.72 17.5291 7.77Z" fill="#E7B41F" />
          <path d="M20.7916 14.6999C19.6716 15.4499 18.1016 15.7299 16.6516 15.5399C17.0316 14.7199 17.2316 13.8099 17.2416 12.8499C17.2416 11.8499 17.0216 10.8999 16.6016 10.0699C18.0816 9.86991 19.6516 10.1499 20.7816 10.8999C22.3616 11.9399 22.3616 13.6499 20.7916 14.6999Z" fill="#E7B41F" />
          <path d="M6.43625 7.77C6.50625 7.76 6.57625 7.76 6.64625 7.77C8.19625 7.72 9.42625 6.45 9.42625 4.89C9.42625 3.29 8.13625 2 6.53625 2C4.94625 2 3.65625 3.29 3.65625 4.89C3.65625 6.45 4.88625 7.72 6.43625 7.77Z" fill="#E7B41F" />
          <path d="M6.54719 12.8501C6.54719 13.8201 6.75719 14.7401 7.13719 15.5701C5.72719 15.7201 4.25719 15.4201 3.17719 14.7101C1.59719 13.6601 1.59719 11.9501 3.17719 10.9001C4.24719 10.1801 5.75719 9.8901 7.17719 10.0501C6.76719 10.8901 6.54719 11.8401 6.54719 12.8501Z" fill="#E7B41F" />
          <path d="M12.1169 15.87C12.0369 15.86 11.9469 15.86 11.8569 15.87C10.0169 15.81 8.54688 14.3 8.54688 12.44C8.55687 10.54 10.0869 9 11.9969 9C13.8969 9 15.4369 10.54 15.4369 12.44C15.4269 14.3 13.9669 15.81 12.1169 15.87Z" fill="#E7B41F" />
          <path d="M8.86687 17.9401C7.35687 18.9501 7.35687 20.6101 8.86687 21.6101C10.5869 22.7601 13.4069 22.7601 15.1269 21.6101C16.6369 20.6001 16.6369 18.9401 15.1269 17.9401C13.4169 16.7901 10.5969 16.7901 8.86687 17.9401Z" fill="#E7B41F" />
        </svg>
      );
    case LINKEDIN:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path fill="#0076b2" d="M10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6s9.6-4.298 9.6-9.6S15.302.4 10 .4M7.65 13.979H5.706V7.723H7.65zm-.984-7.024c-.614 0-1.011-.435-1.011-.973c0-.549.409-.971 1.036-.971s1.011.422 1.023.971c0 .538-.396.973-1.048.973m8.084 7.024h-1.944v-3.467c0-.807-.282-1.355-.985-1.355c-.537 0-.856.371-.997.728c-.052.127-.065.307-.065.486v3.607H8.814v-4.26c0-.781-.025-1.434-.051-1.996h1.689l.089.869h.039c.256-.408.883-1.01 1.932-1.01c1.279 0 2.238.857 2.238 2.699z" /></svg>
      );
    case WHATSAPP:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23.82" height="24" viewBox="0 0 256 258"><defs><linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#1faf38" /><stop offset="100%" stop-color="#60d669" /></linearGradient><linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#f9f9f9" /><stop offset="100%" stop-color="#fff" /></linearGradient></defs><path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004" /><path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z" /><path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64" /></svg>
      );
    case BACKICON:
      return (
        <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.62132 10.5L11.5607 2.56066C12.1464 1.97487 12.1464 1.02513 11.5607 0.43934C10.9749 -0.146447 10.0251 -0.146447 9.43934 0.43934L0.43934 9.43934C-0.146447 10.0251 -0.146447 10.9749 0.43934 11.5607L9.43934 20.5607C10.0251 21.1464 10.9749 21.1464 11.5607 20.5607C12.1464 19.9749 12.1464 19.0251 11.5607 18.4393L3.62132 10.5Z" fill="black" />
        </svg>
      );
    case STAFFCHECK:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#FFD046" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1894 7.15398L14.0691 6.03369L8.31371 11.7891L6.01482 9.49024L4.89453 10.6105L8.24939 13.9654L8.41539 13.7994L8.47971 13.8637L15.1894 7.15398Z"
            fill="white"
          />
        </svg>
      );
    case CART:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 6L9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7V6"
            stroke="#141718"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M15.6113 3H8.38836C6.433 3 4.76424 4.41365 4.44278 6.3424L2.77612 16.3424C2.36976 18.7805 4.24994 21 6.72169 21H17.278C19.7498 21 21.6299 18.7805 21.2236 16.3424L19.5569 6.3424C19.2355 4.41365 17.5667 3 15.6113 3Z"
            stroke="#141718"
            fill="none"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      );
    case BLUELOGO:
      return (
        <svg
          width="75"
          height="20"
          viewBox="0 0 75 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3312 19H11.0032L6.87516 10.456L5.36316 19H0.0351562L3.03516 2.008H8.36316L12.4672 10.696L14.0032 2.008H19.3312L16.3312 19ZM27.0663 19.168C25.6263 19.168 24.3623 18.872 23.2743 18.28C22.1863 17.688 21.3463 16.856 20.7543 15.784C20.1623 14.696 19.8663 13.456 19.8663 12.064C19.8663 10.032 20.2823 8.24 21.1143 6.688C21.9623 5.12 23.1383 3.904 24.6423 3.04C26.1623 2.16 27.9063 1.72 29.8743 1.72C31.3463 1.72 32.6263 2.016 33.7143 2.608C34.8183 3.184 35.6663 4.008 36.2583 5.08C36.8503 6.136 37.1463 7.36 37.1463 8.752C37.1463 10.768 36.7223 12.568 35.8743 14.152C35.0423 15.736 33.8583 16.968 32.3223 17.848C30.8023 18.728 29.0503 19.168 27.0663 19.168ZM27.8823 14.2C28.7143 14.2 29.4343 13.984 30.0423 13.552C30.6663 13.104 31.1383 12.52 31.4583 11.8C31.7783 11.064 31.9383 10.272 31.9383 9.424C31.9383 8.544 31.6983 7.864 31.2183 7.384C30.7543 6.888 30.0823 6.64 29.2023 6.64C28.3703 6.64 27.6423 6.856 27.0183 7.288C26.3943 7.72 25.9143 8.304 25.5783 9.04C25.2583 9.76 25.0983 10.544 25.0983 11.392C25.0983 12.272 25.3303 12.96 25.7943 13.456C26.2743 13.952 26.9703 14.2 27.8823 14.2ZM65.1323 2.008L58.2443 19H51.6203L51.3563 9.352L47.6843 19H41.0603L40.1723 2.008H45.9083L45.5723 12.712L49.7483 2.008H55.5563L55.9643 12.712L59.3963 2.008H65.1323ZM74.411 0.879999L71.795 12.256H67.235L68.603 0.879999H74.411ZM68.291 19.192C67.459 19.192 66.803 18.992 66.323 18.592C65.859 18.192 65.627 17.672 65.627 17.032C65.627 16.472 65.779 15.952 66.083 15.472C66.403 14.992 66.835 14.616 67.379 14.344C67.939 14.056 68.555 13.912 69.227 13.912C70.043 13.912 70.683 14.12 71.147 14.536C71.611 14.936 71.843 15.456 71.843 16.096C71.843 16.656 71.691 17.176 71.387 17.656C71.083 18.12 70.659 18.496 70.115 18.784C69.571 19.056 68.963 19.192 68.291 19.192Z"
            fill="#FFD046"
          />
        </svg>
      );
    case UNLIKE:
      return (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.57886 11.3695L4.28487 18.1111L10.1451 13.6808L16.3551 17.7553L16.3304 17.6883L16.4029 17.7353L13.9892 11.2961L19.4754 7.83058L12.6837 7.78373L10.1451 0.888916L7.81042 7.75012L0.919922 7.70259L6.57886 11.3695Z"
            fill="#8A8A8F"
          />
        </svg>
      );
    case LIKE:
      return (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.43628 11.3695L4.14229 18.1111L10.0025 13.6808L16.2125 17.7553L16.1878 17.6883L16.2603 17.7353L13.8467 11.2961L19.3328 7.83058L12.5411 7.78373L10.0025 0.888916L7.66784 7.75012L0.777344 7.70259L6.43628 11.3695Z"
            fill="#FF9500"
          />
        </svg>
      );
    case HORIZONTALDOTS:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00065 8.66683C8.36884 8.66683 8.66732 8.36835 8.66732 8.00016C8.66732 7.63197 8.36884 7.3335 8.00065 7.3335C7.63246 7.3335 7.33398 7.63197 7.33398 8.00016C7.33398 8.36835 7.63246 8.66683 8.00065 8.66683Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6667 8.66683C13.0349 8.66683 13.3333 8.36835 13.3333 8.00016C13.3333 7.63197 13.0349 7.3335 12.6667 7.3335C12.2985 7.3335 12 7.63197 12 8.00016C12 8.36835 12.2985 8.66683 12.6667 8.66683Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33268 8.66683C3.70087 8.66683 3.99935 8.36835 3.99935 8.00016C3.99935 7.63197 3.70087 7.3335 3.33268 7.3335C2.96449 7.3335 2.66602 7.63197 2.66602 8.00016C2.66602 8.36835 2.96449 8.66683 3.33268 8.66683Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case DELETE:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 4H3.33333H14"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M5.33398 4.00016V2.66683C5.33398 2.31321 5.47446 1.97407 5.72451 1.72402C5.97456 1.47397 6.3137 1.3335 6.66732 1.3335H9.33398C9.68761 1.3335 10.0267 1.47397 10.2768 1.72402C10.5268 1.97407 10.6673 2.31321 10.6673 2.66683V4.00016M12.6673 4.00016V13.3335C12.6673 13.6871 12.5268 14.0263 12.2768 14.2763C12.0267 14.5264 11.6876 14.6668 11.334 14.6668H4.66732C4.3137 14.6668 3.97456 14.5264 3.72451 14.2763C3.47446 14.0263 3.33398 13.6871 3.33398 13.3335V4.00016H12.6673Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66602 7.3335V11.3335"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.33398 7.3335V11.3335"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case EDIT:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 13.3335H14"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 2.33316C11.2652 2.06794 11.6249 1.91895 12 1.91895C12.1857 1.91895 12.3696 1.95553 12.5412 2.0266C12.7128 2.09767 12.8687 2.20184 13 2.33316C13.1313 2.46448 13.2355 2.62038 13.3066 2.79196C13.3776 2.96354 13.4142 3.14744 13.4142 3.33316C13.4142 3.51888 13.3776 3.70277 13.3066 3.87435C13.2355 4.04593 13.1313 4.20184 13 4.33316L4.66667 12.6665L2 13.3332L2.66667 10.6665L11 2.33316Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
            strokeLinejoin="round"
          />
        </svg>
      );
    case PP:
      return (
        <svg
          width="24"
          height="15"
          viewBox="0 0 24 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.767578 15V0.908203H6.25586C9.01953 0.908203 10.9336 2.76367 10.9336 5.52734V5.54688C10.9336 8.30078 9.01953 10.1855 6.25586 10.1855H2.95508V15H0.767578ZM5.70898 2.75391H2.95508V8.34961H5.70898C7.60352 8.34961 8.70703 7.32422 8.70703 5.55664V5.53711C8.70703 3.7793 7.60352 2.75391 5.70898 2.75391ZM13.7559 15V0.908203H19.2441C22.0078 0.908203 23.9219 2.76367 23.9219 5.52734V5.54688C23.9219 8.30078 22.0078 10.1855 19.2441 10.1855H15.9434V15H13.7559ZM18.6973 2.75391H15.9434V8.34961H18.6973C20.5918 8.34961 21.6953 7.32422 21.6953 5.55664V5.53711C21.6953 3.7793 20.5918 2.75391 18.6973 2.75391Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case TC:
      return (
        <svg
          width="26"
          height="16"
          viewBox="0 0 26 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.3418 15V2.79297H0.908203V0.908203H11.9531V2.79297H7.5293V15H5.3418ZM19.873 15.3418C15.957 15.3418 13.5156 12.5098 13.5156 7.96875V7.94922C13.5156 3.39844 15.9473 0.566406 19.8633 0.566406C22.9688 0.566406 25.3516 2.5293 25.7227 5.33203L25.7129 5.38086H23.5449V5.35156C23.1348 3.62305 21.7188 2.5 19.8633 2.5C17.334 2.5 15.752 4.59961 15.752 7.94922V7.96875C15.752 11.3086 17.334 13.4082 19.873 13.4082C21.7383 13.4082 23.1348 12.4121 23.5352 10.8203L23.5547 10.7812H25.7227V10.8398C25.3125 13.5449 23.0176 15.3418 19.873 15.3418Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case ABOUTNOW:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9.51793V13.5604C12 15.3154 10.83 16.4779 9.0825 16.4779H4.4175C2.67 16.4779 1.5 15.3154 1.5 13.5604V7.73293C1.5 5.97793 2.67 4.81543 4.4175 4.81543H7.29C8.0625 4.81543 8.805 5.12293 9.3525 5.67043L11.145 7.45543C11.6925 8.00293 12 8.74543 12 9.51793Z"
            fill="#E7B41F"
          />
          <path
            d="M16.5006 6.18754V10.23C16.5006 11.9775 15.3306 13.1475 13.5831 13.1475H12.7506V9.51754C12.7506 8.55004 12.3606 7.60504 11.6781 6.92254L9.88562 5.13754C9.20312 4.45504 8.25812 4.06504 7.29062 4.06504H6.01562C6.15063 2.50504 7.28312 1.47754 8.91812 1.47754H11.7906C12.5631 1.47754 13.3056 1.78504 13.8531 2.33254L15.6456 4.12504C16.1931 4.67254 16.5006 5.41504 16.5006 6.18754Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case SETUP:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5273 3.66734L10.1323 1.70984C9.48727 1.42484 8.51227 1.42484 7.86727 1.70984L3.47227 3.66734C2.36227 4.16234 2.19727 4.83734 2.19727 5.19734C2.19727 5.55734 2.36227 6.23234 3.47227 6.72734L7.86727 8.68484C8.18977 8.82734 8.59477 8.90234 8.99977 8.90234C9.40477 8.90234 9.80977 8.82734 10.1323 8.68484L14.5273 6.72734C15.6373 6.23234 15.8023 5.55734 15.8023 5.19734C15.8023 4.83734 15.6448 4.16234 14.5273 3.66734Z"
            fill="#E7B41F"
          />
          <path
            d="M9.00023 12.78C8.71523 12.78 8.43023 12.72 8.16774 12.6075L3.11273 10.3575C2.34023 10.0125 1.74023 9.09 1.74023 8.2425C1.74023 7.935 1.98773 7.6875 2.29523 7.6875C2.60273 7.6875 2.85023 7.935 2.85023 8.2425C2.85023 8.6475 3.18773 9.1725 3.56273 9.3375L8.61773 11.5875C8.85773 11.6925 9.13523 11.6925 9.37523 11.5875L14.4302 9.3375C14.8052 9.1725 15.1427 8.655 15.1427 8.2425C15.1427 7.935 15.3902 7.6875 15.6977 7.6875C16.0052 7.6875 16.2527 7.935 16.2527 8.2425C16.2527 9.0825 15.6527 10.0125 14.8802 10.3575L9.82524 12.6075C9.57023 12.72 9.28523 12.78 9.00023 12.78Z"
            fill="#E7B41F"
          />
          <path
            d="M9.00023 16.4997C8.71523 16.4997 8.43023 16.4397 8.16774 16.3272L3.11273 14.0772C2.28023 13.7097 1.74023 12.8772 1.74023 11.9622C1.74023 11.6547 1.98773 11.4072 2.29523 11.4072C2.60273 11.4072 2.85023 11.6547 2.85023 11.9622C2.85023 12.4347 3.12773 12.8622 3.56273 13.0572L8.61773 15.3072C8.85773 15.4122 9.13523 15.4122 9.37523 15.3072L14.4302 13.0572C14.8577 12.8697 15.1427 12.4347 15.1427 11.9622C15.1427 11.6547 15.3902 11.4072 15.6977 11.4072C16.0052 11.4072 16.2527 11.6547 16.2527 11.9622C16.2527 12.8772 15.7127 13.7022 14.8802 14.0772L9.82524 16.3272C9.57023 16.4397 9.28523 16.4997 9.00023 16.4997Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case SUPPORT:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.06188 13.9871C1.75438 13.9871 1.49938 13.7321 1.49938 13.4246V9.14961C1.46188 7.11711 2.21938 5.19711 3.62938 3.75711C5.03938 2.32461 6.92937 1.53711 8.96187 1.53711C13.1169 1.53711 16.4994 4.91961 16.4994 9.07461V13.3496C16.4994 13.6571 16.2444 13.9121 15.9369 13.9121C15.6294 13.9121 15.3744 13.6571 15.3744 13.3496V9.07461C15.3744 5.54211 12.5019 2.66211 8.96187 2.66211C7.22937 2.66211 5.62438 3.32961 4.43188 4.54461C3.23188 5.76711 2.59438 7.39461 2.62438 9.13461V13.4171C2.62438 13.7321 2.37688 13.9871 2.06188 13.9871Z"
            fill="#E7B41F"
          />
          <path
            d="M4.455 9.33789H4.3575C2.7825 9.33789 1.5 10.6204 1.5 12.1954V13.6054C1.5 15.1804 2.7825 16.4629 4.3575 16.4629H4.455C6.03 16.4629 7.3125 15.1804 7.3125 13.6054V12.1954C7.3125 10.6204 6.03 9.33789 4.455 9.33789Z"
            fill="#E7B41F"
          />
          <path
            d="M13.6425 9.33789H13.545C11.97 9.33789 10.6875 10.6204 10.6875 12.1954V13.6054C10.6875 15.1804 11.97 16.4629 13.545 16.4629H13.6425C15.2175 16.4629 16.5 15.1804 16.5 13.6054V12.1954C16.5 10.6204 15.2175 9.33789 13.6425 9.33789Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case HELPCENTER:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
            fill="#E7B41F"
          />
          <path
            d="M17.0809 14.1596C14.2909 12.2996 9.74094 12.2996 6.93094 14.1596C5.66094 14.9996 4.96094 16.1496 4.96094 17.3796C4.96094 18.6096 5.66094 19.7496 6.92094 20.5896C8.32094 21.5296 10.1609 21.9996 12.0009 21.9996C13.8409 21.9996 15.6809 21.5296 17.0809 20.5896C18.3409 19.7396 19.0409 18.5996 19.0409 17.3596C19.0309 16.1396 18.3409 14.9896 17.0809 14.1596ZM14.3309 16.5596L11.8109 19.0796C11.6909 19.1996 11.5309 19.2596 11.3709 19.2596C11.2109 19.2596 11.0509 19.1896 10.9309 19.0796L9.67094 17.8196C9.43094 17.5796 9.43094 17.1796 9.67094 16.9396C9.91094 16.6996 10.3109 16.6996 10.5509 16.9396L11.3709 17.7596L13.4509 15.6796C13.6909 15.4396 14.0909 15.4396 14.3309 15.6796C14.5809 15.9196 14.5809 16.3196 14.3309 16.5596Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case COMMERCIAL:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
            fill="#E7B41F"
          />
          <path
            d="M17.0998 2H12.8998C9.81668 2 8.37074 3.09409 8.06951 5.73901C8.00649 6.29235 8.46476 6.75 9.02167 6.75H11.0998C15.2998 6.75 17.2498 8.7 17.2498 12.9V14.9781C17.2498 15.535 17.7074 15.9933 18.2608 15.9303C20.9057 15.629 21.9998 14.1831 21.9998 11.1V6.9C21.9998 3.4 20.5998 2 17.0998 2Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case STAFF:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 2H6C3 2 2 3.79 2 6V7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7ZM5.97 14.01C5.42 14.01 4.97 13.56 4.97 13.01C4.97 12.46 5.42 12.01 5.97 12.01C6.52 12.01 6.97 12.46 6.97 13.01C6.97 13.56 6.52 14.01 5.97 14.01ZM5.97 10.01C5.42 10.01 4.97 9.56 4.97 9.01C4.97 8.46 5.42 8.01 5.97 8.01C6.52 8.01 6.97 8.46 6.97 9.01C6.97 9.56 6.52 10.01 5.97 10.01ZM12 13.76H9C8.59 13.76 8.25 13.42 8.25 13.01C8.25 12.6 8.59 12.26 9 12.26H12C12.41 12.26 12.75 12.6 12.75 13.01C12.75 13.42 12.41 13.76 12 13.76ZM12 9.76H9C8.59 9.76 8.25 9.42 8.25 9.01C8.25 8.6 8.59 8.26 9 8.26H12C12.41 8.26 12.75 8.6 12.75 9.01C12.75 9.42 12.41 9.76 12 9.76Z"
            fill="#E7B41F"
          />
          <path
            d="M18.01 2V3.5C18.67 3.5 19.3 3.77 19.76 4.22C20.24 4.71 20.5 5.34 20.5 6V8.42C20.5 9.16 20.17 9.5 19.42 9.5H17.5V4.01C17.5 3.73 17.73 3.5 18.01 3.5V2ZM18.01 2C16.9 2 16 2.9 16 4.01V11H19.42C21 11 22 10 22 8.42V6C22 4.9 21.55 3.9 20.83 3.17C20.1 2.45 19.11 2.01 18.01 2C18.02 2 18.01 2 18.01 2Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case INSIGHT:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case WALLET:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.9963 12.6201V14.6801C21.9963 15.2401 21.5363 15.7001 20.9663 15.7001H19.0363C17.9563 15.7001 16.9663 14.9101 16.8763 13.8301C16.8163 13.2001 17.0563 12.6101 17.4763 12.2001C17.8463 11.8201 18.3563 11.6001 18.9163 11.6001H20.9663C21.5363 11.6001 21.9963 12.0601 21.9963 12.6201Z" fill="#E7B41F" />
          <path d="M15.38 13.9599C15.29 12.9099 15.67 11.8799 16.43 11.1299C17.07 10.4799 17.96 10.0999 18.92 10.0999H19.49C19.77 10.0999 20 9.8699 19.96 9.5899C19.69 7.6499 18.01 6.1499 16 6.1499H6C3.79 6.1499 2 7.9399 2 10.1499V17.1499C2 19.3599 3.79 21.1499 6 21.1499H16C18.02 21.1499 19.69 19.6499 19.96 17.7099C20 17.4299 19.77 17.1999 19.49 17.1999H19.04C17.14 17.1999 15.54 15.7799 15.38 13.9599ZM13 11.8999H7C6.59 11.8999 6.25 11.5699 6.25 11.1499C6.25 10.7299 6.59 10.3999 7 10.3999H13C13.41 10.3999 13.75 10.7399 13.75 11.1499C13.75 11.5599 13.41 11.8999 13 11.8999Z" fill="#E7B41F" />
          <path d="M14.2067 3.9801C14.4667 4.2501 14.2367 4.6501 13.8567 4.6501H6.02673C4.93673 4.6501 3.91673 4.9701 3.06673 5.5201C2.67673 5.7701 2.14673 5.5001 2.33673 5.0701C2.89673 3.7601 4.20673 2.8501 5.71673 2.8501H11.3367C12.4967 2.8501 13.5267 3.2601 14.2067 3.9801Z" fill="#E7B41F" />
        </svg>

      );
    case EP:
      return (
        <svg
          width="26"
          height="17"
          viewBox="0 0 26 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0327148 17V0.794434H10.3198V2.96191H2.54834V7.70117H9.9043V9.79004H2.54834V14.8325H10.3198V17H0.0327148ZM13.9585 17V0.794434H20.27C23.4482 0.794434 25.6494 2.92822 25.6494 6.10645V6.12891C25.6494 9.2959 23.4482 11.4634 20.27 11.4634H16.4741V17H13.9585ZM19.6411 2.91699H16.4741V9.35205H19.6411C21.8198 9.35205 23.0889 8.17285 23.0889 6.14014V6.11768C23.0889 4.09619 21.8198 2.91699 19.6411 2.91699Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case NOTIFICATION:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.59611 13.3332L5.57945 12.3482C5.89445 12.0332 6.06778 11.6149 6.06778 11.1699V7.27236C6.06778 6.14153 6.55945 5.06069 7.41778 4.30903C8.28278 3.55069 9.38445 3.21736 10.5319 3.36819C12.4711 3.62569 13.9336 5.37903 13.9336 7.44736V11.1699C13.9336 11.6149 14.1069 12.0332 14.4211 12.3474L15.4053 13.3332H4.59611ZM11.6669 15.284C11.6669 16.0332 10.9036 16.6665 10.0003 16.6665C9.09695 16.6665 8.33361 16.0332 8.33361 15.284V14.9999H11.6669V15.284ZM17.1011 12.6732L15.6003 11.1699V7.44736C15.6003 4.54653 13.5153 2.08236 10.7503 1.71653C9.14861 1.50319 7.53195 1.99236 6.31945 3.05569C5.09945 4.12403 4.40111 5.66069 4.40111 7.27236L4.40028 11.1699L2.89945 12.6732C2.50861 13.0649 2.39278 13.6474 2.60445 14.1582C2.81695 14.6699 3.31111 14.9999 3.86445 14.9999H6.66695V15.284C6.66695 16.9657 8.16195 18.3332 10.0003 18.3332C11.8386 18.3332 13.3336 16.9657 13.3336 15.284V14.9999H16.1361C16.6894 14.9999 17.1828 14.6699 17.3944 14.159C17.6069 13.6474 17.4919 13.064 17.1011 12.6732Z"
            fill="#666E7D"
          />
        </svg>
      );
    case SETTING:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.48047 16.6665H10.523V16.0273C10.523 15.2482 11.0021 14.5482 11.743 14.2423C12.5096 13.9232 13.3471 14.0798 13.8988 14.6348L14.348 15.0857L15.088 14.3457L14.6338 13.8923C14.0813 13.3407 13.9255 12.504 14.2363 11.7615C14.2363 11.7615 14.2371 11.7607 14.2371 11.7598L14.2463 11.7365C14.5496 11.0007 15.2505 10.5207 16.0296 10.5207H16.668V9.479H16.0296C15.2505 9.479 14.5496 8.99984 14.2446 8.259C13.9238 7.49234 14.0813 6.65484 14.6363 6.10234L15.0871 5.65317L14.348 4.914L13.8938 5.36817C13.3421 5.91984 12.5063 6.07567 11.7638 5.76567C11.003 5.4515 10.523 4.7515 10.523 3.97234V3.33317H9.48047V3.97234C9.48047 4.7515 9.0013 5.4515 8.26047 5.75734C7.49464 6.07817 6.65714 5.92067 6.10464 5.36484L5.65547 4.914L4.91547 5.654L5.36964 6.10734C5.9213 6.659 6.07797 7.49567 5.76714 8.23817C5.4538 8.999 4.75297 9.479 3.9738 9.479H3.33464V10.5207H3.9738C4.75297 10.5207 5.4538 10.9998 5.7588 11.7407C6.07964 12.5073 5.92214 13.3448 5.36714 13.8973L4.9163 14.3465L5.65547 15.0857L6.10964 14.6315C6.6613 14.0798 7.49714 13.924 8.23964 14.234C9.00047 14.5482 9.48047 15.2482 9.48047 16.0273V16.6665ZM10.7871 18.3332H9.21047C8.44047 18.3332 7.8138 17.7065 7.8138 16.9365V16.0273C7.8138 15.9048 7.7163 15.8207 7.62464 15.7832C7.50463 15.734 7.3763 15.724 7.28797 15.8098L6.6463 16.4523C6.09964 16.9973 5.2113 16.999 4.66547 16.4523L3.5488 15.3357C3.2838 15.0707 3.1388 14.719 3.1388 14.344C3.13964 13.9698 3.28547 13.6182 3.5513 13.3532L4.1913 12.7157C4.2788 12.6282 4.26964 12.4998 4.23047 12.4073C4.18047 12.2848 4.09714 12.1873 3.9738 12.1873H3.07047C2.29714 12.1873 1.66797 11.559 1.66797 10.7857V9.209C1.66797 8.43817 2.29464 7.81234 3.06547 7.81234H3.9738C4.0963 7.81234 4.18047 7.714 4.21797 7.62234C4.26797 7.50234 4.27797 7.37317 4.1913 7.2865L3.5488 6.64484C3.0038 6.09734 3.0038 5.209 3.5488 4.664L4.66547 3.54734C4.93047 3.28234 5.2813 3.13734 5.65547 3.13734H5.65714C6.0313 3.13734 6.3838 3.28317 6.64797 3.549L7.28547 4.18984C7.37297 4.27817 7.50214 4.26817 7.59464 4.229C7.7163 4.17817 7.8138 4.09484 7.8138 3.97234V3.069C7.8138 2.29567 8.44297 1.6665 9.2163 1.6665H10.793C11.563 1.6665 12.1896 2.29317 12.1896 3.06317V3.97234C12.1896 4.09484 12.2871 4.179 12.3788 4.2165C12.4996 4.2665 12.628 4.27734 12.7155 4.18984L13.3571 3.54734C13.9038 3.00234 14.7921 3.00067 15.338 3.54734L16.4555 4.66484C16.7205 4.929 16.8655 5.28067 16.8646 5.65567C16.8646 6.029 16.7188 6.3815 16.453 6.64567L15.8121 7.284C15.7246 7.3715 15.7338 7.49984 15.773 7.59234C15.823 7.71484 15.9063 7.81234 16.0296 7.81234H16.933C17.7063 7.81234 18.3346 8.44067 18.3346 9.214V10.7907C18.3346 11.5615 17.7088 12.1873 16.938 12.1873H16.0296C15.9071 12.1873 15.823 12.2857 15.7855 12.3773C15.7846 12.3782 15.7746 12.4032 15.7738 12.4048C15.7355 12.4973 15.7255 12.6265 15.8121 12.7132L16.4546 13.3548C16.9996 13.9023 16.9996 14.7907 16.4546 15.3357L15.338 16.4523C15.073 16.7173 14.7221 16.8623 14.348 16.8623H14.3463C13.9721 16.8623 13.6196 16.7165 13.3555 16.4507L12.718 15.8098C12.6305 15.7223 12.5005 15.7323 12.4088 15.7707C12.2871 15.8215 12.1896 15.9048 12.1896 16.0273V16.9307C12.1896 17.704 11.5605 18.3332 10.7871 18.3332ZM10.0017 8.74984C9.31255 8.74984 8.75172 9.31067 8.75172 9.99984C8.75172 10.689 9.31255 11.2498 10.0017 11.2498C10.6909 11.2498 11.2517 10.689 11.2517 9.99984C11.2517 9.31067 10.6909 8.74984 10.0017 8.74984ZM10.0017 12.9165C8.39338 12.9165 7.08505 11.6082 7.08505 9.99984C7.08505 8.3915 8.39338 7.08317 10.0017 7.08317C11.6101 7.08317 12.9184 8.3915 12.9184 9.99984C12.9184 11.6082 11.6101 12.9165 10.0017 12.9165Z"
            fill="#666E7D"
          />
        </svg>
      );
    case VIDEO:
      return (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.166016" y="0.249512" width="9.5" height="9.5" rx="4.75" fill="#D1D5DB" />
          <path
            d="M2.38477 3.73294C2.38477 3.56497 2.45149 3.40388 2.57026 3.28511C2.68904 3.16634 2.85013 3.09961 3.0181 3.09961H4.9181C5.08607 3.09961 5.24716 3.16634 5.36593 3.28511C5.48471 3.40388 5.55143 3.56497 5.55143 3.73294V6.26628C5.55143 6.43425 5.48471 6.59534 5.36593 6.71411C5.24716 6.83288 5.08607 6.89961 4.9181 6.89961H3.0181C2.85013 6.89961 2.68904 6.83288 2.57026 6.71411C2.45149 6.59534 2.38477 6.43425 2.38477 6.26628V3.73294ZM6.35988 4.08318C6.30729 4.10946 6.26305 4.14986 6.23212 4.19986C6.20119 4.24986 6.1848 4.30748 6.18477 4.36628V5.63294C6.1848 5.69174 6.20119 5.74936 6.23212 5.79936C6.26305 5.84936 6.30729 5.88976 6.35988 5.91604L6.99322 6.23271C7.04148 6.25683 7.09511 6.26821 7.14901 6.26579C7.20292 6.26336 7.2553 6.2472 7.30121 6.21884C7.34711 6.19048 7.385 6.15086 7.4113 6.10374C7.43759 6.05662 7.4514 6.00357 7.45143 5.94961V4.04961C7.4514 3.99565 7.43759 3.9426 7.4113 3.89548C7.385 3.84836 7.34711 3.80874 7.30121 3.78038C7.2553 3.75202 7.20292 3.73586 7.14901 3.73343C7.09511 3.731 7.04148 3.74239 6.99322 3.76651L6.35988 4.08318Z"
            fill="#18181B"
          />
        </svg>
      );
    case RIGHTARROW:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.33398 8.00016H12.6673M12.6673 8.00016L8.00065 3.3335M12.6673 8.00016L8.00065 12.6668"
            stroke="#8E95A9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case THREEDOT:
      return (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 8.47698C13.1 8.47698 14 7.57018 14 6.46188C14 5.35357 13.1 4.44678 12 4.44678C10.9 4.44678 10 5.35357 10 6.46188C10 7.57018 10.9 8.47698 12 8.47698ZM12 10.4921C10.9 10.4921 10 11.3989 10 12.5072C10 13.6155 10.9 14.5223 12 14.5223C13.1 14.5223 14 13.6155 14 12.5072C14 11.3989 13.1 10.4921 12 10.4921ZM12 16.5374C10.9 16.5374 10 17.4442 10 18.5525C10 19.6608 10.9 20.5676 12 20.5676C13.1 20.5676 14 19.6608 14 18.5525C14 17.4442 13.1 16.5374 12 16.5374Z"
            fill="#898989"
          />
        </svg>
      );
    case BUCKET:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
            fill="#E7B41F"
          />
          <path
            d="M19.0506 12H4.87064C4.25064 12 3.78064 12.55 3.88064 13.16L4.72064 18.3C5.00064 20.02 5.75064 22 9.08064 22H14.6906C18.0606 22 18.6606 20.31 19.0206 18.42L20.0306 13.19C20.1506 12.57 19.6806 12 19.0506 12ZM10.6106 18.45C10.6106 18.84 10.3006 19.15 9.92064 19.15C9.53064 19.15 9.22064 18.84 9.22064 18.45V15.15C9.22064 14.77 9.53064 14.45 9.92064 14.45C10.3006 14.45 10.6106 14.77 10.6106 15.15V18.45ZM14.8906 18.45C14.8906 18.84 14.5806 19.15 14.1906 19.15C13.8106 19.15 13.4906 18.84 13.4906 18.45V15.15C13.4906 14.77 13.8106 14.45 14.1906 14.45C14.5806 14.45 14.8906 14.77 14.8906 15.15V18.45Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case ACCEPTCODE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
            fill="#E7B41F"
          />
          <path
            d="M17.0998 2H12.8998C9.81668 2 8.37074 3.09409 8.06951 5.73901C8.00649 6.29235 8.46476 6.75 9.02167 6.75H11.0998C15.2998 6.75 17.2498 8.7 17.2498 12.9V14.9781C17.2498 15.535 17.7074 15.9933 18.2608 15.9303C20.9057 15.629 21.9998 14.1831 21.9998 11.1V6.9C21.9998 3.4 20.5998 2 17.0998 2Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case SCANQR:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9V7C21.25 4.42 19.58 2.75 17 2.75H7C4.42 2.75 2.75 4.42 2.75 7V9C2.75 9.41 2.41 9.75 2 9.75C1.59 9.75 1.25 9.41 1.25 9V7C1.25 3.56 3.56 1.25 7 1.25H17C20.44 1.25 22.75 3.56 22.75 7V9C22.75 9.41 22.41 9.75 22 9.75Z" fill="#E7B41F" />
          <path d="M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V15C21.25 14.59 21.59 14.25 22 14.25C22.41 14.25 22.75 14.59 22.75 15V17C22.75 20.44 20.44 22.75 17 22.75Z" fill="#E7B41F" />
          <path d="M16.3962 8.20996L12.6363 6.17996C12.2363 5.96996 11.7663 5.96996 11.3663 6.17996L7.59625 8.20996C7.32625 8.35996 7.15625 8.64996 7.15625 8.96996C7.15625 9.29996 7.32625 9.58996 7.59625 9.73996L11.3562 11.77C11.5562 11.88 11.7763 11.93 11.9963 11.93C12.2162 11.93 12.4363 11.88 12.6363 11.77L16.3962 9.73996C16.6663 9.58996 16.8363 9.29996 16.8363 8.96996C16.8363 8.64996 16.6663 8.35996 16.3962 8.20996Z" fill="#E7B41F" />
          <path d="M10.74 12.4699L7.24 10.7199C6.97 10.5899 6.66 10.5999 6.4 10.7599C6.15 10.9199 6 11.1899 6 11.4899V14.7999C6 15.3699 6.32 15.8899 6.83 16.1399L10.33 17.8899C10.45 17.9499 10.58 17.9799 10.72 17.9799C10.88 17.9799 11.03 17.9399 11.17 17.8499C11.43 17.6899 11.58 17.4199 11.58 17.1199V13.8099C11.57 13.2399 11.26 12.7299 10.74 12.4699Z" fill="#E7B41F" />
          <path d="M17.5919 10.7599C17.3319 10.5999 17.0219 10.5899 16.7519 10.7199L13.2519 12.4699C12.7419 12.7299 12.4219 13.2399 12.4219 13.8099V17.1199C12.4219 17.4199 12.5719 17.6899 12.8319 17.8499C12.9719 17.9399 13.1219 17.9799 13.2819 17.9799C13.4119 17.9799 13.5419 17.9499 13.6719 17.8899L17.1719 16.1399C17.6819 15.8799 18.0019 15.3699 18.0019 14.7999V11.4899C18.0019 11.1899 17.8519 10.9199 17.5919 10.7599Z" fill="#E7B41F" />
        </svg>

      );
    case BUZZ:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.9105 10.7199H14.8205V3.5199C14.8205 1.8399 13.9105 1.4999 12.8005 2.7599L12.0005 3.6699L5.2305 11.3699C4.3005 12.4199 4.6905 13.2799 6.0905 13.2799H9.1805V20.4799C9.1805 22.1599 10.0905 22.4999 11.2005 21.2399L12.0005 20.3299L18.7705 12.6299C19.7005 11.5799 19.3105 10.7199 17.9105 10.7199Z"
            fill="#E7B41F"
          />
        </svg>
      );
    case TOTAL:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H22C22.41 1.25 22.75 1.59 22.75 2C22.75 2.41 22.41 2.75 22 2.75Z" fill="#7B61FF" />
          <path d="M16.6722 22.34C16.5422 22.6 16.2722 22.75 16.0022 22.75C15.8922 22.75 15.7722 22.72 15.6722 22.67L12.0022 20.84L8.33221 22.67C8.23221 22.72 8.11221 22.75 8.00221 22.75C7.73221 22.75 7.46221 22.6 7.33221 22.34C7.14221 21.96 7.29221 21.51 7.67221 21.33L11.2522 19.54V17H12.7522V19.54L16.3322 21.33C16.7122 21.51 16.8622 21.96 16.6722 22.34Z" fill="#7B61FF" />
          <path d="M3 2V14.1C3 16 4 17 5.9 17H18.1C20 17 21 16 21 14.1V2H3ZM16.98 8.58L13.83 11.21C13.54 11.45 13.17 11.55 12.82 11.49C12.46 11.43 12.15 11.21 11.96 10.89L10.91 9.14L7.98 11.58C7.84 11.7 7.67 11.75 7.5 11.75C7.29 11.75 7.07 11.66 6.92 11.48C6.65 11.16 6.7 10.69 7.02 10.42L10.17 7.79C10.46 7.55 10.83 7.45 11.18 7.51C11.54 7.57 11.85 7.79 12.04 8.11L13.09 9.86L16.02 7.42C16.34 7.15 16.81 7.2 17.08 7.52C17.34 7.84 17.3 8.31 16.98 8.58Z" fill="#7B61FF" />
        </svg>
      );
    case TRENDUP:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.0422 6.82018L14.2822 2.79018C12.7122 1.69018 10.3022 1.75018 8.79219 2.92018L3.78219 6.83018C2.78219 7.61018 1.99219 9.21018 1.99219 10.4702V17.3702C1.99219 19.9202 4.06219 22.0002 6.61219 22.0002H17.3922C19.9422 22.0002 22.0122 19.9302 22.0122 17.3802V10.6002C22.0122 9.25018 21.1422 7.59018 20.0422 6.82018ZM16.8822 13.4002C16.8822 13.7902 16.5722 14.1002 16.1822 14.1002C15.7922 14.1002 15.4822 13.7902 15.4822 13.4002V13.2202L12.7622 15.9402C12.6122 16.0902 12.4122 16.1602 12.2022 16.1402C12.0022 16.1202 11.8122 16.0002 11.7022 15.8302L10.6822 14.3102L8.30219 16.6902C8.16219 16.8302 7.99219 16.8902 7.81219 16.8902C7.63219 16.8902 7.45219 16.8202 7.32219 16.6902C7.05219 16.4202 7.05219 15.9802 7.32219 15.7002L10.3022 12.7202C10.4522 12.5702 10.6522 12.5002 10.8622 12.5202C11.0722 12.5402 11.2622 12.6502 11.3722 12.8302L12.3922 14.3502L14.5022 12.2402H14.3222C13.9322 12.2402 13.6222 11.9302 13.6222 11.5402C13.6222 11.1502 13.9322 10.8402 14.3222 10.8402H16.1822C16.2722 10.8402 16.3622 10.8602 16.4522 10.8902C16.6222 10.9602 16.7622 11.1002 16.8322 11.2702C16.8722 11.3602 16.8822 11.4502 16.8822 11.5402V13.4002Z" fill="#F4BE21" />
        </svg>

      );
    case SOLD:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.97 16H18.03C16.76 16 16 16.76 16 18.03V20.97C16 22.24 16.76 23 18.03 23H20.97C22.24 23 23 22.24 23 20.97V18.03C23 16.76 22.24 16 20.97 16ZM21.63 18.45L19.26 21.22C19.16 21.33 19.03 21.4 18.88 21.4C18.88 21.4 18.87 21.4 18.86 21.4C18.73 21.4 18.59 21.35 18.5 21.25L17.4 20.17C17.2 19.97 17.2 19.64 17.4 19.43C17.6 19.23 17.93 19.23 18.14 19.43L18.83 20.12L20.84 17.78C21.02 17.56 21.35 17.53 21.57 17.72C21.79 17.91 21.81 18.24 21.63 18.45Z" fill="#10B981" />
          <path d="M20.97 16H18.03C16.76 16 16 16.76 16 18.03V20.97C16 22.24 16.76 23 18.03 23H20.97C22.24 23 23 22.24 23 20.97V18.03C23 16.76 22.24 16 20.97 16ZM21.63 18.45L19.26 21.22C19.16 21.33 19.03 21.4 18.88 21.4C18.88 21.4 18.87 21.4 18.86 21.4C18.73 21.4 18.59 21.35 18.5 21.25L17.4 20.17C17.2 19.97 17.2 19.64 17.4 19.43C17.6 19.23 17.93 19.23 18.14 19.43L18.83 20.12L20.84 17.78C21.02 17.56 21.35 17.53 21.57 17.72C21.79 17.91 21.81 18.24 21.63 18.45Z" fill="#10B981" />
          <path d="M21.97 7.21C21.69 4.48 19.52 2.31 16.79 2.03C16.59 2.01 16.39 2 16.19 2H7.81C7.61 2 7.41 2.01 7.21 2.03C4.48 2.31 2.31 4.48 2.03 7.21C2.01 7.41 2 7.61 2 7.81V16.19C2 16.39 2.01 16.59 2.03 16.79C2.31 19.52 4.48 21.69 7.21 21.97C7.41 21.99 7.61 22 7.81 22H14C14.55 22 15 21.55 15 21V18.03C15 16.36 16.36 15 18.03 15H21C21.55 15 22 14.55 22 14V7.81C22 7.61 21.99 7.41 21.97 7.21ZM7.75 13.5C7.75 13.91 7.41 14.25 7 14.25C6.59 14.25 6.25 13.91 6.25 13.5V10.5C6.25 10.09 6.59 9.75 7 9.75C7.41 9.75 7.75 10.09 7.75 10.5V13.5ZM12.75 13.5C12.75 13.91 12.41 14.25 12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V10.5C11.25 10.09 11.59 9.75 12 9.75C12.41 9.75 12.75 10.09 12.75 10.5V13.5Z" fill="#10B981" />
        </svg>
      );
    case DEALS:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.1199 14.9399L19.4399 15.5899C19.5999 15.9099 20.0099 16.2099 20.3499 16.2699L20.7799 16.3399C22.0899 16.5599 22.3899 17.5199 21.4599 18.4599L21.0599 18.8599C20.7899 19.1299 20.6499 19.6499 20.7299 20.0299L20.7799 20.2699C21.1399 21.8499 20.2999 22.4599 18.9299 21.6299L18.6399 21.4499C18.2899 21.2399 17.7099 21.2399 17.3599 21.4499L17.0699 21.6299C15.6899 22.4599 14.8599 21.8499 15.2199 20.2699L15.2699 20.0299C15.3499 19.6599 15.2099 19.1299 14.9399 18.8599L14.5399 18.4599C13.6099 17.5099 13.9099 16.5599 15.2199 16.3399L15.6499 16.2699C15.9999 16.2099 16.3999 15.9099 16.5599 15.5899L16.8799 14.9399C17.4999 13.6899 18.4999 13.6899 19.1199 14.9399Z" fill="#007BFF" />
          <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H13.09C13.44 22 13.69 21.64 13.65 21.29C13.61 20.91 13.63 20.46 13.75 19.94C13.77 19.87 13.75 19.79 13.69 19.73L13.47 19.51C12.62 18.65 12.31 17.61 12.61 16.66C12.92 15.72 13.78 15.06 14.97 14.86L15.27 14.81L15.54 14.27C16.09 13.15 16.99 12.5 18 12.5C19.01 12.5 19.91 13.15 20.46 14.27L20.61 14.58C20.68 14.73 20.82 14.83 20.98 14.86C21.07 14.88 21.16 14.9 21.25 14.92C21.6 15.01 22 14.73 22 14.36V7.81C22 4.17 19.83 2 16.19 2ZM16.26 8.96L13.95 11.94C13.66 12.31 13.25 12.55 12.78 12.6C12.32 12.66 11.85 12.53 11.49 12.24L9.66 10.82C9.59 10.76 9.51 10.76 9.47 10.77C9.43 10.77 9.36 10.79 9.3 10.87L6.92 13.96C6.77 14.15 6.55 14.25 6.32 14.25C6.16 14.25 6 14.2 5.86 14.09C5.53 13.84 5.47 13.37 5.72 13.04L8.1 9.95C8.39 9.58 8.8 9.34 9.27 9.28C9.74 9.22 10.2 9.35 10.57 9.64L12.4 11.08C12.47 11.14 12.54 11.13 12.59 11.13C12.63 11.13 12.7 11.11 12.76 11.03L15.07 8.05C15.32 7.72 15.79 7.66 16.12 7.92C16.46 8.17 16.51 8.64 16.26 8.96Z" fill="#007BFF" />
        </svg>

      );
    case ACTIVE_ITEMS:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.1199 14.9399L19.4399 15.5899C19.5999 15.9099 20.0099 16.2099 20.3499 16.2699L20.7799 16.3399C22.0899 16.5599 22.3899 17.5199 21.4599 18.4599L21.0599 18.8599C20.7899 19.1299 20.6499 19.6499 20.7299 20.0299L20.7799 20.2699C21.1399 21.8499 20.2999 22.4599 18.9299 21.6299L18.6399 21.4499C18.2899 21.2399 17.7099 21.2399 17.3599 21.4499L17.0699 21.6299C15.6899 22.4599 14.8599 21.8499 15.2199 20.2699L15.2699 20.0299C15.3499 19.6599 15.2099 19.1299 14.9399 18.8599L14.5399 18.4599C13.6099 17.5099 13.9099 16.5599 15.2199 16.3399L15.6499 16.2699C15.9999 16.2099 16.3999 15.9099 16.5599 15.5899L16.8799 14.9399C17.4999 13.6899 18.4999 13.6899 19.1199 14.9399Z" fill="#007BFF" />
          <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H13.09C13.44 22 13.69 21.64 13.65 21.29C13.61 20.91 13.63 20.46 13.75 19.94C13.77 19.87 13.75 19.79 13.69 19.73L13.47 19.51C12.62 18.65 12.31 17.61 12.61 16.66C12.92 15.72 13.78 15.06 14.97 14.86L15.27 14.81L15.54 14.27C16.09 13.15 16.99 12.5 18 12.5C19.01 12.5 19.91 13.15 20.46 14.27L20.61 14.58C20.68 14.73 20.82 14.83 20.98 14.86C21.07 14.88 21.16 14.9 21.25 14.92C21.6 15.01 22 14.73 22 14.36V7.81C22 4.17 19.83 2 16.19 2ZM16.26 8.96L13.95 11.94C13.66 12.31 13.25 12.55 12.78 12.6C12.32 12.66 11.85 12.53 11.49 12.24L9.66 10.82C9.59 10.76 9.51 10.76 9.47 10.77C9.43 10.77 9.36 10.79 9.3 10.87L6.92 13.96C6.77 14.15 6.55 14.25 6.32 14.25C6.16 14.25 6 14.2 5.86 14.09C5.53 13.84 5.47 13.37 5.72 13.04L8.1 9.95C8.39 9.58 8.8 9.34 9.27 9.28C9.74 9.22 10.2 9.35 10.57 9.64L12.4 11.08C12.47 11.14 12.54 11.13 12.59 11.13C12.63 11.13 12.7 11.11 12.76 11.03L15.07 8.05C15.32 7.72 15.79 7.66 16.12 7.92C16.46 8.17 16.51 8.64 16.26 8.96Z" fill="#007BFF" />
        </svg>

      );
    case ACTIVE_DEALS:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.91 16.19C9.91 16.83 9.39 17.35 8.74 17.35C8.1 17.35 7.58 16.83 7.58 16.19V12.93C7.58 12.29 8.1 11.77 8.74 11.77C9.39 11.77 9.91 12.29 9.91 12.93V16.19ZM16.42 16.19C16.42 16.83 15.9 17.35 15.26 17.35C14.61 17.35 14.09 16.83 14.09 16.19V7.81C14.09 7.17 14.61 6.65 15.26 6.65C15.9 6.65 16.42 7.17 16.42 7.81V16.19Z" fill="#BF1B82" />
        </svg>
      );
    case HEALTH:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 7.81V12.5H17.92C17.8 12.49 17.54 12.34 17.48 12.23L16.44 10.26C16.03 9.48 15.32 9.04 14.56 9.08C13.8 9.12 13.15 9.63 12.82 10.46L11.44 13.92L11.24 13.4C10.75 12.13 9.35 11.17 7.97 11.17L2 11.2V7.81C2 4.17 4.17 2 7.81 2H16.19C19.83 2 22 4.17 22 7.81Z" fill="#FF4E40" />
          <path d="M22 16.1901V14.0001H17.92C17.25 14.0001 16.46 13.5201 16.15 12.9301L15.11 10.9601C14.83 10.4301 14.43 10.4601 14.21 11.0101L11.91 16.8201C11.66 17.4701 11.24 17.4701 10.98 16.8201L9.84 13.9401C9.57 13.2401 8.73 12.6701 7.98 12.6701L2 12.7001V16.1901C2 19.7701 4.1 21.9301 7.63 21.9901C7.74 22.0001 7.86 22.0001 7.97 22.0001H15.97C16.12 22.0001 16.27 22.0001 16.41 21.9901C19.92 21.9101 22 19.7601 22 16.1901Z" fill="#FF4E40" />
          <path d="M1.99875 12.7002V16.0102C1.97875 15.6902 1.96875 15.3502 1.96875 15.0002V12.7002H1.99875Z" fill="#FF4E40" />
        </svg>

      );
    case UPARROW:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 1.2 1.2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path width="48" height="48" fill="white" fillOpacity="0.01" d="M0 0h1.2v1.2H0z" />
          <path
            d="M0.325 0.751 0.625 0.451l0.3 0.3"
            stroke="#000000"
            strokeWidth="0.09999999999999999"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case DOWNARROW:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 1.2 1.2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path width="48" height="48" fill="white" fillOpacity="0.01" d="M0 0h1.2v1.2H0z" />
          <path
            d="M0.925 0.449 0.625 0.751 0.325 0.449"
            stroke="#000000"
            strokeWidth="0.09999999999999999"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case TWITTER:
      return <img src={twitterIcon} />;
    case PINTEREST:
      return (
        <svg
          width="25px"
          height="25px"
          viewBox="0 0 1.5 1.5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            cx="24"
            cy="24"
            r="20"
            fill="#BD081C"
            d="M1.375 0.75A0.625 0.625 0 0 1 0.75 1.375A0.625 0.625 0 0 1 0.125 0.75A0.625 0.625 0 0 1 1.375 0.75z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.777 0.375C0.572 0.375 0.469 0.522 0.469 0.644c0 0.074 0.028 0.14 0.088 0.165 0.01 0.004 0.019 0 0.022 -0.011 0.002 -0.008 0.007 -0.027 0.009 -0.035 0.003 -0.011 0.002 -0.015 -0.006 -0.024 -0.017 -0.02 -0.028 -0.047 -0.028 -0.084 0 -0.109 0.081 -0.206 0.212 -0.206 0.116 0 0.179 0.071 0.179 0.165 0 0.124 -0.055 0.229 -0.137 0.229 -0.045 0 -0.079 -0.037 -0.068 -0.083 0.013 -0.055 0.038 -0.114 0.038 -0.153 0 -0.035 -0.019 -0.065 -0.058 -0.065 -0.046 0 -0.083 0.048 -0.083 0.112 0 0.041 0.014 0.068 0.014 0.068l-0.055 0.235c-0.016 0.07 -0.002 0.155 -0.001 0.164 0.001 0.005 0.007 0.006 0.01 0.002 0.004 -0.006 0.059 -0.073 0.078 -0.141 0.005 -0.019 0.03 -0.118 0.03 -0.118 0.015 0.029 0.059 0.054 0.105 0.054 0.139 0 0.232 -0.126 0.232 -0.295 0 -0.128 -0.108 -0.247 -0.273 -0.247"
            fill="white"
          />
        </svg>
      );
    case FREEDELIVERY:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.5 15.5C21.78 15.5 22 15.72 22 16V17C22 18.66 20.66 20 19 20C19 18.35 17.65 17 16 17C14.35 17 13 18.35 13 20H11C11 18.35 9.65 17 8 17C6.35 17 5 18.35 5 20C3.34 20 2 18.66 2 17V15C2 14.45 2.45 14 3 14H12.5C13.88 14 15 12.88 15 11.5V6C15 5.45 15.45 5 16 5H16.84C17.56 5 18.22 5.39 18.58 6.01L19.22 7.13C19.31 7.29 19.19 7.5 19 7.5C17.62 7.5 16.5 8.62 16.5 10V13C16.5 14.38 17.62 15.5 19 15.5H21.5Z"
            fill="#FFD046"
          />
          <path
            d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
            fill="#FFD046"
          />
          <path
            d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
            fill="#FFD046"
          />
          <path
            d="M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z"
            fill="#FFD046"
          />
          <path
            d="M13.08 2H5.69C3.65 2 2 3.65 2 5.69V12.07C2 12.62 2.45 13.07 3 13.07H12.15C13.17 13.07 14 12.24 14 11.22V2.92C14 2.41 13.59 2 13.08 2ZM10.07 7.07L7.98 9.09C7.83 9.23 7.64 9.3 7.46 9.3C7.27 9.3 7.08 9.23 6.94 9.09L5.93 8.13C5.63 7.84 5.62 7.36 5.91 7.06C6.19 6.76 6.67 6.76 6.97 7.04L7.46 7.51L9.03 5.99C9.33 5.7 9.8 5.71 10.09 6.01C10.38 6.31 10.37 6.78 10.07 7.07Z"
            fill="#FFD046"
          />
        </svg>
      );
    case PROMOS:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5484 20.1599C13.2884 20.2699 13.0084 20.3699 12.7084 20.4699L11.1284 20.9899C7.15839 22.2699 5.06839 21.1999 3.77839 17.2299L2.49839 13.2799C1.21839 9.30992 2.27839 7.20992 6.24839 5.92992L7.78839 5.41992C7.59839 5.89992 7.43839 6.44992 7.28839 7.06992L6.30839 11.2599C5.20839 15.9699 6.81839 18.5699 11.5284 19.6899L13.2084 20.0899C13.3184 20.1199 13.4384 20.1399 13.5484 20.1599Z"
            fill="#FFD046"
          />
          <path
            d="M17.1702 3.21001L15.5002 2.82001C12.1602 2.03001 10.1702 2.68001 9.00018 5.10001C8.70018 5.71001 8.46018 6.45001 8.26018 7.30001L7.28018 11.49C6.30018 15.67 7.59018 17.73 11.7602 18.72L13.4402 19.12C14.0202 19.26 14.5602 19.35 15.0602 19.39C18.1802 19.69 19.8402 18.23 20.6802 14.62L21.6602 10.44C22.6402 6.26001 21.3602 4.19001 17.1702 3.21001Z"
            fill="#FFD046"
          />
        </svg>
      );
    case CASHBACK:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
            fill="#FFD046"
          />
          <path
            d="M7.99887 17.78C7.58887 17.78 7.24887 17.44 7.24887 17.03C7.24887 16.61 7.58887 16.28 7.99887 16.28H19.7589C20.0589 16.28 20.2889 16.02 20.2589 15.72L19.5789 10.03C19.3389 8.09 18.9989 6.5 15.5989 6.5H8.39887C4.99887 6.5 4.65887 8.09 4.42887 10.03L3.52887 17.53C3.23887 19.99 3.99887 22 7.50887 22H16.4889C19.6489 22 20.5789 20.37 20.5289 18.25C20.5189 17.98 20.2989 17.78 20.0289 17.78H7.99887Z"
            fill="#FFD046"
          />
        </svg>
      );
    case GROUPDISCOUNT:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5291 7.77C17.4591 7.76 17.3891 7.76 17.3191 7.77C15.7691 7.72 14.5391 6.45 14.5391 4.89C14.5391 3.3 15.8291 2 17.4291 2C19.0191 2 20.3191 3.29 20.3191 4.89C20.3091 6.45 19.0791 7.72 17.5291 7.77Z"
            fill="#FFD046"
          />
          <path
            d="M20.7916 14.6999C19.6716 15.4499 18.1016 15.7299 16.6516 15.5399C17.0316 14.7199 17.2316 13.8099 17.2416 12.8499C17.2416 11.8499 17.0216 10.8999 16.6016 10.0699C18.0816 9.86991 19.6516 10.1499 20.7816 10.8999C22.3616 11.9399 22.3616 13.6499 20.7916 14.6999Z"
            fill="#FFD046"
          />
          <path
            d="M6.44016 7.77C6.51016 7.76 6.58016 7.76 6.65016 7.77C8.20016 7.72 9.43016 6.45 9.43016 4.89C9.43016 3.29 8.14016 2 6.54016 2C4.95016 2 3.66016 3.29 3.66016 4.89C3.66016 6.45 4.89016 7.72 6.44016 7.77Z"
            fill="#FFD046"
          />
          <path
            d="M6.55109 12.8501C6.55109 13.8201 6.76109 14.7401 7.14109 15.5701C5.73109 15.7201 4.26109 15.4201 3.18109 14.7101C1.60109 13.6601 1.60109 11.9501 3.18109 10.9001C4.25109 10.1801 5.76109 9.8901 7.18109 10.0501C6.77109 10.8901 6.55109 11.8401 6.55109 12.8501Z"
            fill="#FFD046"
          />
          <path
            d="M12.1208 15.87C12.0408 15.86 11.9508 15.86 11.8608 15.87C10.0208 15.81 8.55078 14.3 8.55078 12.44C8.56078 10.54 10.0908 9 12.0008 9C13.9008 9 15.4408 10.54 15.4408 12.44C15.4308 14.3 13.9708 15.81 12.1208 15.87Z"
            fill="#FFD046"
          />
          <path
            d="M8.87078 17.9401C7.36078 18.9501 7.36078 20.6101 8.87078 21.6101C10.5908 22.7601 13.4108 22.7601 15.1308 21.6101C16.6408 20.6001 16.6408 18.9401 15.1308 17.9401C13.4208 16.7901 10.6008 16.7901 8.87078 17.9401Z"
            fill="#FFD046"
          />
        </svg>
      );
    case REFERRAL:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
            fill="#FFD046"
          />
          <path
            d="M14.0809 14.1499C11.2909 12.2899 6.74094 12.2899 3.93094 14.1499C2.66094 14.9999 1.96094 16.1499 1.96094 17.3799C1.96094 18.6099 2.66094 19.7499 3.92094 20.5899C5.32094 21.5299 7.16094 21.9999 9.00094 21.9999C10.8409 21.9999 12.6809 21.5299 14.0809 20.5899C15.3409 19.7399 16.0409 18.5999 16.0409 17.3599C16.0309 16.1299 15.3409 14.9899 14.0809 14.1499Z"
            fill="#FFD046"
          />
          <path
            d="M19.9894 7.3401C20.1494 9.2801 18.7694 10.9801 16.8594 11.2101C16.8494 11.2101 16.8494 11.2101 16.8394 11.2101H16.8094C16.7494 11.2101 16.6894 11.2101 16.6394 11.2301C15.6694 11.2801 14.7794 10.9701 14.1094 10.4001C15.1394 9.4801 15.7294 8.1001 15.6094 6.6001C15.5394 5.7901 15.2594 5.0501 14.8394 4.4201C15.2194 4.2301 15.6594 4.1101 16.1094 4.0701C18.0694 3.9001 19.8194 5.3601 19.9894 7.3401Z"
            fill="#FFD046"
          />
          <path
            d="M21.9883 16.5899C21.9083 17.5599 21.2883 18.3999 20.2483 18.9699C19.2483 19.5199 17.9883 19.7799 16.7383 19.7499C17.4583 19.0999 17.8783 18.2899 17.9583 17.4299C18.0583 16.1899 17.4683 14.9999 16.2883 14.0499C15.6183 13.5199 14.8383 13.0999 13.9883 12.7899C16.1983 12.1499 18.9783 12.5799 20.6883 13.9599C21.6083 14.6999 22.0783 15.6299 21.9883 16.5899Z"
            fill="#FFD046"
          />
        </svg>
      );
    case GIFT:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z"
            fill="#FFD046"
          />
          <path
            d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z"
            fill="#FFD046"
          />
          <path
            d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z"
            fill="#FFD046"
          />
          <path
            d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
            fill="#FFD046"
          />
        </svg>
      );
    case OFFER:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
            fill="#FFD046"
          />
          <path
            d="M19.0506 12H4.87064C4.25064 12 3.78064 12.55 3.88064 13.16L4.72064 18.3C5.00064 20.02 5.75064 22 9.08064 22H14.6906C18.0606 22 18.6606 20.31 19.0206 18.42L20.0306 13.19C20.1506 12.57 19.6806 12 19.0506 12ZM12.0006 19.5C9.66064 19.5 7.75064 17.59 7.75064 15.25C7.75064 14.84 8.09064 14.5 8.50064 14.5C8.91064 14.5 9.25064 14.84 9.25064 15.25C9.25064 16.77 10.4806 18 12.0006 18C13.5206 18 14.7506 16.77 14.7506 15.25C14.7506 14.84 15.0906 14.5 15.5006 14.5C15.9106 14.5 16.2506 14.84 16.2506 15.25C16.2506 17.59 14.3406 19.5 12.0006 19.5Z"
            fill="#FFD046"
          />
        </svg>
      );
    case BOGODEALS:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.9597 8.9599C19.2897 8.2199 18.2797 7.7899 16.8797 7.6399V6.8799C16.8797 5.5099 16.2997 4.1899 15.2797 3.2699C14.2497 2.3299 12.9097 1.8899 11.5197 2.0199C9.12975 2.2499 7.11975 4.5599 7.11975 7.0599V7.6399C5.71975 7.7899 4.70975 8.2199 4.03975 8.9599C3.06975 10.0399 3.09975 11.4799 3.20975 12.4799L3.90975 18.0499C4.11975 19.9999 4.90975 21.9999 9.20975 21.9999H14.7897C19.0897 21.9999 19.8797 19.9999 20.0897 18.0599L20.7897 12.4699C20.8997 11.4799 20.9197 10.0399 19.9597 8.9599ZM11.6597 3.4099C12.6597 3.3199 13.6097 3.6299 14.3497 4.2999C15.0797 4.9599 15.4897 5.8999 15.4897 6.8799V7.5799H8.50975V7.0599C8.50975 5.2799 9.97975 3.5699 11.6597 3.4099ZM8.41975 13.1499H8.40975C7.85975 13.1499 7.40975 12.6999 7.40975 12.1499C7.40975 11.5999 7.85975 11.1499 8.40975 11.1499C8.96975 11.1499 9.41975 11.5999 9.41975 12.1499C9.41975 12.6999 8.96975 13.1499 8.41975 13.1499ZM15.4197 13.1499H15.4097C14.8597 13.1499 14.4097 12.6999 14.4097 12.1499C14.4097 11.5999 14.8597 11.1499 15.4097 11.1499C15.9697 11.1499 16.4197 11.5999 16.4197 12.1499C16.4197 12.6999 15.9697 13.1499 15.4197 13.1499Z"
            fill="#FFD046"
          />
        </svg>
      );
    case DISCOUNT:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
            fill="#FFD046"
          />
          <path
            d="M19.0506 12H4.87064C4.25064 12 3.78064 12.55 3.88064 13.16L4.72064 18.3C5.00064 20.02 5.75064 22 9.08064 22H14.6906C18.0606 22 18.6606 20.31 19.0206 18.42L20.0306 13.19C20.1506 12.57 19.6806 12 19.0506 12ZM10.6106 18.45C10.6106 18.84 10.3006 19.15 9.92064 19.15C9.53064 19.15 9.22064 18.84 9.22064 18.45V15.15C9.22064 14.77 9.53064 14.45 9.92064 14.45C10.3006 14.45 10.6106 14.77 10.6106 15.15V18.45ZM14.8906 18.45C14.8906 18.84 14.5806 19.15 14.1906 19.15C13.8106 19.15 13.4906 18.84 13.4906 18.45V15.15C13.4906 14.77 13.8106 14.45 14.1906 14.45C14.5806 14.45 14.8906 14.77 14.8906 15.15V18.45Z"
            fill="#FFD046"
          />
        </svg>
      );
    case GRID:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z"
            fill="#8A8A8F"
            fillOpacity="0.5"
          />
          <path
            d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
            fill="#8A8A8F"
            fillOpacity="0.5"
          />
          <path
            d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
            fill="#8A8A8F"
            fillOpacity="0.5"
          />
          <path
            d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
            fill="#8A8A8F"
            fillOpacity="0.5"
          />
          <path
            d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
            fill="#8A8A8F"
            fillOpacity="0.5"
          />
        </svg>
      );
    case FILTER:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M10.7419 14.3023C10.7419 14.7598 10.4419 15.3598 10.0594 15.5923L9.00188 16.2748C8.01938 16.8823 6.65437 16.1998 6.65437 14.9848V10.9723C6.65437 10.4398 6.35437 9.75732 6.04688 9.38232L3.16685 6.35232C2.78435 5.96982 2.48438 5.29483 2.48438 4.83733V3.09732C2.48438 2.18982 3.16689 1.50732 3.99939 1.50732H14.0044C14.8369 1.50732 15.5194 2.18982 15.5194 3.02232V4.68732C15.5194 5.29482 15.1369 6.05232 14.7619 6.42732"
            stroke="#8A8A8F"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M12.0524 12.3898C13.3778 12.3898 14.4524 11.3153 14.4524 9.98985C14.4524 8.66437 13.3778 7.58984 12.0524 7.58984C10.7269 7.58984 9.65234 8.66437 9.65234 9.98985C9.65234 11.3153 10.7269 12.3898 12.0524 12.3898Z"
            stroke="#8A8A8F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M14.9023 12.8398L14.1523 12.0898"
            stroke="#8A8A8F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case YELLOWUNCHECK:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="9.5" fill="white" stroke="#D8D8D8" />
        </svg>
      );
    case YELLOWCHECK:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#FFD046" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1894 7.15398L14.0691 6.03369L8.31371 11.7891L6.01482 9.49024L4.89453 10.6105L8.24939 13.9654L8.41539 13.7994L8.47971 13.8637L15.1894 7.15398Z"
            fill="white"
          />
        </svg>
      );
    case CHECKED:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z"
            fill="#10B981"
          />
        </svg>
      );
    case UNCHECK:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM13.92 10.75H5.92C5.51 10.75 5.17 10.41 5.17 10C5.17 9.59 5.51 9.25 5.92 9.25H13.92C14.33 9.25 14.67 9.59 14.67 10C14.67 10.41 14.34 10.75 13.92 10.75Z"
            fill="#DCE2EF"
          />
        </svg>
      );
    case CSV:
      return (
        <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 26 26" width="26" height="26">
          <g id="XMLID_14_">
            <path
              id="XMLID_15_"
              d="M24.935 9.018h-3.648V5.621L15.291 0H1.065v26h20.223v-3.786h3.648zm-2.167 11.03H7.601V11.185h15.167z"
            />
            <path
              id="XMLID_18_"
              d="M9.776 16.91q0.289 0.328 0.689 0.53t0.883 0.203q0.273 0 0.559 -0.07a2.34 2.34 0 0 0 0.537 -0.203 1.95 1.95 0 0 0 0.451 -0.328 1.3 1.3 0 0 0 0.308 -0.448l-0.718 -0.413q-0.077 0.185 -0.203 0.315 -0.127 0.13 -0.277 0.213a1.3 1.3 0 0 1 -0.315 0.121q-0.165 0.038 -0.317 0.038 -0.293 0 -0.537 -0.127a1.3 1.3 0 0 1 -0.42 -0.337q-0.174 -0.209 -0.27 -0.486a1.82 1.82 0 0 1 -0.095 -0.575q0 -0.267 0.083 -0.537t0.244 -0.484 0.407 -0.346 0.575 -0.134q0.152 0 0.312 0.035t0.305 0.112 0.273 0.207 0.216 0.321l0.673 -0.464q-0.222 -0.438 -0.677 -0.712 -0.455 -0.273 -1.078 -0.273 -0.528 0 -0.941 0.198t-0.699 0.515a2.21 2.21 0 0 0 -0.436 0.722q-0.15 0.403 -0.15 0.816 0 0.433 0.163 0.849 0.161 0.416 0.451 0.744"
            />
            <path
              id="XMLID_19_"
              d="M15.372 16.869q-0.26 0 -0.508 -0.064t-0.451 -0.156q-0.204 -0.092 -0.352 -0.185t-0.207 -0.15l-0.387 0.757q0.394 0.28 0.889 0.432t1.004 0.152q0.33 0 0.632 -0.073t0.534 -0.231 0.369 -0.416 0.137 -0.62q0 -0.311 -0.101 -0.524t-0.289 -0.365 -0.458 -0.255 -0.601 -0.191a10.4 10.4 0 0 1 -0.448 -0.121q-0.194 -0.057 -0.321 -0.127t-0.194 -0.163 -0.066 -0.231q0 -0.242 0.178 -0.374t0.541 -0.134q0.203 0 0.4 0.051a2.6 2.6 0 0 1 0.365 0.124q0.169 0.073 0.286 0.15t0.163 0.121l0.387 -0.712q-0.299 -0.203 -0.699 -0.352t-0.878 -0.15q-0.343 0 -0.642 0.092t-0.524 0.27 -0.352 0.445 -0.127 0.61q0 0.26 0.079 0.448t0.238 0.33q0.159 0.143 0.398 0.248 0.238 0.105 0.563 0.194l0.484 0.14q0.216 0.064 0.369 0.14t0.235 0.178q0.083 0.101 0.083 0.248 0 0.464 -0.724 0.464"
            />
            <path
              id="XMLID_20_"
              points="271.985,243.772 296.361,181.292 283.601,181.292 266.881,228.548 249.985,181.292 
                237.225,181.292 261.777,243.772 	"
              d="m19.643 17.606 1.76 -4.512h-0.92l-1.208 3.413 -1.221 -3.413h-0.922l1.773 4.512Z"
            />
          </g>
        </svg>
      );
    case FOOTERINSTAGRAM:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            fill="none"
            x="2"
            y="2"
            width="20"
            height="20"
            rx="4"
            stroke="#FEFEFE"
            strokeWidth="1.5"
          />
          <circle cx="18" cy="6" r="1" fill="#FEFEFE" />
          <circle fill="none" cx="12" cy="12" r="5" stroke="#FEFEFE" strokeWidth="1.5" />
        </svg>
      );
    case FOOTERFACEBOOK:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 3H15C12.2386 3 10 5.23858 10 8V10H6V14H10V21H14V14H18V10H14V8C14 7.44772 14.4477 7 15 7H18V3Z"
            stroke="#FEFEFE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case FOOTERYOUTUBE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            fill="none"
            x="2"
            y="3"
            width="20"
            height="18"
            rx="4"
            stroke="#FEFEFE"
            strokeWidth="1.5"
          />
          <path
            d="M10.4472 8.72361L15.2111 11.1056C15.9482 11.4741 15.9482 12.5259 15.2111 12.8944L10.4472 15.2764C9.78231 15.6088 9 15.1253 9 14.382V9.61803C9 8.87465 9.78231 8.39116 10.4472 8.72361Z"
            stroke="#FEFEFE"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case LOGO:
      return (
        <svg
          width="75"
          height="20"
          viewBox="0 0 75 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3312 19H11.0032L6.87516 10.456L5.36316 19H0.0351562L3.03516 2.008H8.36316L12.4672 10.696L14.0032 2.008H19.3312L16.3312 19ZM27.0663 19.168C25.6263 19.168 24.3623 18.872 23.2743 18.28C22.1863 17.688 21.3463 16.856 20.7543 15.784C20.1623 14.696 19.8663 13.456 19.8663 12.064C19.8663 10.032 20.2823 8.24 21.1143 6.688C21.9623 5.12 23.1383 3.904 24.6423 3.04C26.1623 2.16 27.9063 1.72 29.8743 1.72C31.3463 1.72 32.6263 2.016 33.7143 2.608C34.8183 3.184 35.6663 4.008 36.2583 5.08C36.8503 6.136 37.1463 7.36 37.1463 8.752C37.1463 10.768 36.7223 12.568 35.8743 14.152C35.0423 15.736 33.8583 16.968 32.3223 17.848C30.8023 18.728 29.0503 19.168 27.0663 19.168ZM27.8823 14.2C28.7143 14.2 29.4343 13.984 30.0423 13.552C30.6663 13.104 31.1383 12.52 31.4583 11.8C31.7783 11.064 31.9383 10.272 31.9383 9.424C31.9383 8.544 31.6983 7.864 31.2183 7.384C30.7543 6.888 30.0823 6.64 29.2023 6.64C28.3703 6.64 27.6423 6.856 27.0183 7.288C26.3943 7.72 25.9143 8.304 25.5783 9.04C25.2583 9.76 25.0983 10.544 25.0983 11.392C25.0983 12.272 25.3303 12.96 25.7943 13.456C26.2743 13.952 26.9703 14.2 27.8823 14.2ZM65.1323 2.008L58.2443 19H51.6203L51.3563 9.352L47.6843 19H41.0603L40.1723 2.008H45.9083L45.5723 12.712L49.7483 2.008H55.5563L55.9643 12.712L59.3963 2.008H65.1323ZM74.411 0.879999L71.795 12.256H67.235L68.603 0.879999H74.411ZM68.291 19.192C67.459 19.192 66.803 18.992 66.323 18.592C65.859 18.192 65.627 17.672 65.627 17.032C65.627 16.472 65.779 15.952 66.083 15.472C66.403 14.992 66.835 14.616 67.379 14.344C67.939 14.056 68.555 13.912 69.227 13.912C70.043 13.912 70.683 14.12 71.147 14.536C71.611 14.936 71.843 15.456 71.843 16.096C71.843 16.656 71.691 17.176 71.387 17.656C71.083 18.12 70.659 18.496 70.115 18.784C69.571 19.056 68.963 19.192 68.291 19.192Z"
            fill="white"
          />
        </svg>
      );
    case EMAIL:
      return (
        <svg
          width="21"
          height="16"
          viewBox="0 0 21 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.07577 2.53081C2.23201 2.01864 2.70828 1.64606 3.27156 1.64606H17.2716C17.8349 1.64606 18.3111 2.01864 18.4674 2.53081L10.2716 7.99467L2.07577 2.53081ZM0.521598 2.88232C0.521459 2.89032 0.521448 2.89832 0.521564 2.90631V12.8961C0.521564 14.4148 1.75278 15.6461 3.27156 15.6461H17.2716C18.7903 15.6461 20.0216 14.4148 20.0216 12.8961V2.90629M18.5216 4.29744V12.8961C18.5216 13.5864 17.9619 14.1461 17.2716 14.1461H3.27156C2.58121 14.1461 2.02156 13.5864 2.02156 12.8961V4.29744L9.85554 9.52009C10.1075 9.68804 10.4357 9.68804 10.6876 9.52009L18.5216 4.29744ZM20.0215 2.88235C20.0141 1.36987 18.7858 0.146057 17.2716 0.146057H3.27156C1.75736 0.146057 0.528995 1.36986 0.521598 2.88232"
            fill="#141718"
          />
        </svg>
      );
    case DISLIKE:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="10" fill="white" stroke="#EFEFF4" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 16C20.5035 9.85208 14.099 4.69575 11 8.06719C7.90104 4.69575 1.49654 9.85208 11 16Z"
            fill="#C8C7CC"
          />
        </svg>
      );
    case LOCATION:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipRule="url(#clip0_2359_45885)">
            <path
              d="M8 9C7.50555 9 7.0222 8.85338 6.61108 8.57868C6.19995 8.30397 5.87952 7.91353 5.6903 7.45671C5.50108 6.99989 5.45157 6.49723 5.54804 6.01228C5.6445 5.52732 5.8826 5.08187 6.23223 4.73223C6.58187 4.3826 7.02732 4.1445 7.51228 4.04804C7.99723 3.95157 8.4999 4.00108 8.95671 4.1903C9.41353 4.37952 9.80397 4.69995 10.0787 5.11108C10.3534 5.5222 10.5 6.00555 10.5 6.5C10.4992 7.16281 10.2356 7.79826 9.76693 8.26693C9.29826 8.73561 8.66281 8.99925 8 9ZM8 5C7.70333 5 7.41332 5.08797 7.16665 5.2528C6.91997 5.41762 6.72771 5.65189 6.61418 5.92598C6.50065 6.20007 6.47095 6.50167 6.52882 6.79264C6.5867 7.08361 6.72956 7.35088 6.93934 7.56066C7.14912 7.77044 7.41639 7.9133 7.70737 7.97118C7.99834 8.02906 8.29994 7.99935 8.57403 7.88582C8.84812 7.77229 9.08238 7.58003 9.24721 7.33336C9.41203 7.08668 9.5 6.79667 9.5 6.5C9.49956 6.10231 9.34139 5.72103 9.06018 5.43982C8.77897 5.15861 8.39769 5.00044 8 5Z"
              fill="#FFD046"
            />
            <path
              d="M8.00001 15L3.78226 10.0257C3.75831 9.9971 3.60816 9.7999 3.60816 9.7999C2.88761 8.85084 2.49832 7.6916 2.50001 6.5C2.50001 5.04131 3.07947 3.64236 4.11092 2.61091C5.14237 1.57946 6.54131 1 8.00001 1C9.4587 1 10.8576 1.57946 11.8891 2.61091C12.9205 3.64236 13.5 5.04131 13.5 6.5C13.5018 7.69111 13.1128 8.84991 12.3926 9.79865L12.3919 9.7999C12.3919 9.7999 12.2419 9.9971 12.2195 10.0236L8.00001 15ZM4.40626 9.1975C4.40676 9.19785 4.52296 9.3516 4.54956 9.3847L8.00001 13.4539L11.455 9.37895C11.477 9.35135 11.5942 9.1965 11.5944 9.1961C12.183 8.42064 12.5012 7.47356 12.5 6.5C12.5 5.30653 12.0259 4.16193 11.182 3.31802C10.3381 2.47411 9.19348 2 8.00001 2C6.80653 2 5.66194 2.47411 4.81802 3.31802C3.97411 4.16193 3.50001 5.30653 3.50001 6.5C3.4989 7.47409 3.81725 8.42167 4.40626 9.1975Z"
              fill="#FFD046"
            />
          </g>
          <defs>
            <clipPath id="clip0_2359_45885">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case SEARCH:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2359_45878)">
            <path
              d="M14.5001 13.7931L10.7241 10.017C11.6314 8.9277 12.0839 7.5305 11.9873 6.11608C11.8908 4.70165 11.2526 3.37891 10.2057 2.423C9.15867 1.4671 7.78347 0.951637 6.36612 0.983845C4.94877 1.01605 3.5984 1.59345 2.59593 2.59593C1.59345 3.5984 1.01605 4.94877 0.983845 6.36612C0.951637 7.78347 1.4671 9.15867 2.423 10.2057C3.37891 11.2526 4.70165 11.8908 6.11608 11.9873C7.5305 12.0839 8.9277 11.6314 10.017 10.7241L13.7931 14.5001L14.5001 13.7931ZM2.00012 6.50012C2.00012 5.6101 2.26404 4.74007 2.75851 4.00005C3.25297 3.26003 3.95578 2.68325 4.77804 2.34266C5.60031 2.00207 6.50511 1.91295 7.37802 2.08658C8.25094 2.26022 9.05276 2.6888 9.6821 3.31814C10.3114 3.94747 10.74 4.7493 10.9137 5.62221C11.0873 6.49513 10.9982 7.39993 10.6576 8.22219C10.317 9.04446 9.7402 9.74726 9.00018 10.2417C8.26016 10.7362 7.39013 11.0001 6.50012 11.0001C5.30705 10.9988 4.16323 10.5243 3.3196 9.68064C2.47597 8.83701 2.00144 7.69319 2.00012 6.50012Z"
              fill="#FFD046"
            />
          </g>
          <defs>
            <clipPath id="clip0_2359_45878">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case UPLOAD:
      return (
        <svg
          width="78"
          height="75"
          viewBox="0 0 78 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M70.46 52.9998L60.2875 30.1561C56.8425 22.4061 50.505 22.0936 46.2475 29.4686L40.105 40.1248C36.985 45.5311 31.1675 45.9998 27.1375 41.1561L26.4225 40.2811C22.23 35.2186 16.315 35.8436 13.2925 41.6248L7.7025 52.4061C3.77 59.9061 9.4575 68.7498 18.1675 68.7498H59.6375C68.0875 68.7498 73.775 60.4686 70.46 52.9998Z"
            stroke="#8A8A8F"
            fill="none"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.6523 25C28.0371 25 32.4023 20.8027 32.4023 15.625C32.4023 10.4473 28.0371 6.25 22.6523 6.25C17.2676 6.25 12.9023 10.4473 12.9023 15.625C12.9023 20.8027 17.2676 25 22.6523 25Z"
            stroke="#8A8A8F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case MINUS:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM13.92 10.75H5.92C5.51 10.75 5.17 10.41 5.17 10C5.17 9.59 5.51 9.25 5.92 9.25H13.92C14.33 9.25 14.67 9.59 14.67 10C14.67 10.41 14.34 10.75 13.92 10.75Z"
            fill="#0C0507"
          />
        </svg>
      );
    case PLUS:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14 10.75H10.75V14C10.75 14.41 10.41 14.75 10 14.75C9.59 14.75 9.25 14.41 9.25 14V10.75H6C5.59 10.75 5.25 10.41 5.25 10C5.25 9.59 5.59 9.25 6 9.25H9.25V6C9.25 5.59 9.59 5.25 10 5.25C10.41 5.25 10.75 5.59 10.75 6V9.25H14C14.41 9.25 14.75 9.59 14.75 10C14.75 10.41 14.41 10.75 14 10.75Z"
            fill="#0C0507"
          />
        </svg>
      );
    case GOOGLE:
      return (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5005 12.7331C22.5005 11.8698 22.4291 11.2398 22.2744 10.5864H12.2148V14.483H18.1196C18.0006 15.4514 17.3577 16.9097 15.9291 17.8897L15.9091 18.0202L19.0897 20.4349L19.3101 20.4564C21.3338 18.6247 22.5005 15.9297 22.5005 12.7331Z"
            fill="#4285F4"
          />
          <path
            d="M12.214 23.0001C15.1068 23.0001 17.5353 22.0667 19.3092 20.4567L15.9282 17.89C15.0235 18.5083 13.8092 18.94 12.214 18.94C9.38069 18.94 6.97596 17.1083 6.11874 14.5767L5.99309 14.5871L2.68583 17.0955L2.64258 17.2133C4.40446 20.6433 8.0235 23.0001 12.214 23.0001Z"
            fill="#34A853"
          />
          <path
            d="M6.12095 14.5767C5.89476 13.9234 5.76386 13.2233 5.76386 12.5C5.76386 11.7767 5.89476 11.0767 6.10905 10.4234L6.10306 10.2842L2.75435 7.7356L2.64478 7.78667C1.91862 9.21002 1.50195 10.8084 1.50195 12.5C1.50195 14.1917 1.91862 15.79 2.64478 17.2133L6.12095 14.5767Z"
            fill="#FBBC05"
          />
          <path
            d="M12.2141 6.05997C14.2259 6.05997 15.583 6.91163 16.3569 7.62335L19.3807 4.73C17.5236 3.03834 15.1069 2 12.2141 2C8.02353 2 4.40447 4.35665 2.64258 7.78662L6.10686 10.4233C6.97598 7.89166 9.38073 6.05997 12.2141 6.05997Z"
            fill="#EB4335"
          />
        </svg>
      );
    case FACEBOOK:
      return (
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16.5" r="14" fill="#0C82EE" />
          <path
            d="M21.2137 20.7816L21.8356 16.8301H17.9452V14.267C17.9452 13.1857 18.4877 12.1311 20.2302 12.1311H22V8.76699C22 8.76699 20.3945 8.5 18.8603 8.5C15.6548 8.5 13.5617 10.3929 13.5617 13.8184V16.8301H10V20.7816H13.5617V30.3345C14.2767 30.444 15.0082 30.5 15.7534 30.5C16.4986 30.5 17.2302 30.444 17.9452 30.3345V20.7816H21.2137Z"
            fill="white"
          />
        </svg>
      );
    case TIKTOK:
      return (
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.89483 17.8185C8.03157 16.6863 8.4959 16.0525 9.37093 15.4026C10.6229 14.5226 12.1869 15.0204 12.1869 15.0204V12.0671C12.5671 12.0574 12.9474 12.08 13.3235 12.1345V15.9351C13.3235 15.9351 11.76 15.4372 10.508 16.3177C9.63348 16.9671 9.1682 17.6014 9.03193 18.7336C9.02766 19.3484 9.14303 20.152 9.67431 20.8469C9.54296 20.7795 9.40907 20.7028 9.27265 20.6166C8.10231 19.8307 7.88913 18.6517 7.89483 17.8185ZM19.781 6.60655C18.9197 5.66278 18.594 4.7099 18.4763 4.04053H19.5598C19.5598 4.04053 19.3437 5.79565 20.9181 7.52165L20.9399 7.54486C20.5156 7.27795 20.1265 6.9629 19.781 6.60655ZM25.0003 9.28224V13.0064C25.0003 13.0064 23.6177 12.9522 22.5946 12.6919C21.1659 12.3279 20.2477 11.7695 20.2477 11.7695C20.2477 11.7695 19.6134 11.3714 19.5621 11.3436V19.0339C19.5621 19.4621 19.4449 20.5315 19.0873 21.4234C18.6206 22.5901 17.9004 23.356 17.7679 23.5125C17.7679 23.5125 16.892 24.5478 15.3465 25.2449C13.9535 25.8738 12.7305 25.8579 12.3649 25.8738C12.3649 25.8738 10.2507 25.9575 8.34825 24.7211C7.93685 24.4486 7.55284 24.14 7.20117 23.7992L7.21067 23.806C9.1136 25.0424 11.2273 24.9587 11.2273 24.9587C11.5934 24.9428 12.8164 24.9587 14.209 24.3298C15.753 23.6327 16.6304 22.5974 16.6304 22.5974C16.7614 22.4409 17.485 21.675 17.9498 20.5078C18.3063 19.6164 18.4246 18.5466 18.4246 18.1184V10.429C18.4758 10.4572 19.1097 10.8553 19.1097 10.8553C19.1097 10.8553 20.0284 11.4141 21.457 11.7777C22.4806 12.038 23.8627 12.0922 23.8627 12.0922V9.17394C24.3356 9.27996 24.7387 9.30863 25.0003 9.28224Z"
            fill="#EE1D52"
          />
          <path
            d="M23.8632 9.17393V12.0913C23.8632 12.0913 22.4812 12.0371 21.4575 11.7768C20.0289 11.4128 19.1102 10.8544 19.1102 10.8544C19.1102 10.8544 18.4764 10.4563 18.4251 10.428V18.1193C18.4251 18.5475 18.3078 19.6173 17.9503 20.5087C17.4836 21.676 16.7634 22.4418 16.6309 22.5983C16.6309 22.5983 15.7544 23.6336 14.2095 24.3307C12.817 24.9596 11.5939 24.9437 11.2279 24.9596C11.2279 24.9596 9.11414 25.0433 7.21121 23.8069L7.20171 23.8001C7.0008 23.6056 6.81169 23.4002 6.6353 23.1849C6.02805 22.4445 5.65582 21.569 5.56229 21.3192C5.56213 21.3181 5.56213 21.3171 5.56229 21.316C5.41178 20.8819 5.09558 19.8394 5.13878 18.8296C5.21522 17.0481 5.84194 15.9546 6.00763 15.6807C6.44648 14.9337 7.01724 14.2653 7.69454 13.7053C8.29221 13.2221 8.96965 12.8376 9.69907 12.5677C10.4876 12.2507 11.332 12.0808 12.1869 12.0671V15.0204C12.1869 15.0204 10.623 14.5244 9.37147 15.4026C8.49644 16.0525 8.03211 16.6863 7.89537 17.8185C7.88967 18.6517 8.10285 19.8307 9.27224 20.6171C9.40866 20.7035 9.54255 20.7803 9.6739 20.8473C9.8782 21.1129 10.1268 21.3443 10.4098 21.5322C11.5521 22.2552 12.5093 22.3057 13.7333 21.8361C14.5494 21.5221 15.1638 20.8145 15.4487 20.0305C15.6277 19.5409 15.6253 19.048 15.6253 18.5384V4.04053H18.474C18.5917 4.7099 18.9174 5.66278 19.7787 6.60655C20.1242 6.9629 20.5133 7.27795 20.9376 7.54486C21.063 7.67455 21.7039 8.31571 22.5267 8.70933C22.9522 8.91279 23.4006 9.06868 23.8632 9.17393Z"
            fill="black"
          />
          <path
            d="M4.42773 20.4124V20.4146L4.49842 20.6062C4.4903 20.5839 4.46403 20.5161 4.42773 20.4124Z"
            fill="#69C9D0"
          />
          <path
            d="M9.69872 12.5678C8.96929 12.8378 8.29185 13.2222 7.69418 13.7054C7.01668 14.2667 6.44605 14.9364 6.00776 15.6849C5.84206 15.9579 5.21535 17.0523 5.13891 18.8338C5.0957 19.8436 5.41191 20.8861 5.56241 21.3202C5.56225 21.3213 5.56225 21.3224 5.56241 21.3234C5.65737 21.571 6.02817 22.4465 6.63542 23.1891C6.81181 23.4044 7.00093 23.6098 7.20183 23.8043C6.55812 23.3776 5.98403 22.8618 5.49832 22.2736C4.89629 21.5396 4.52501 20.6731 4.42816 20.4174C4.42804 20.4156 4.42804 20.4138 4.42816 20.4119V20.4088C4.27718 19.9751 3.96002 18.9321 4.00418 17.921C4.08062 16.1395 4.70733 15.046 4.87303 14.7721C5.31119 14.0235 5.88183 13.3537 6.55945 12.7926C7.157 12.3092 7.83447 11.9248 8.56399 11.655C9.01902 11.474 9.49305 11.3405 9.97789 11.2568C10.7086 11.1346 11.4548 11.124 12.1889 11.2254V12.0673C11.3332 12.0807 10.488 12.2506 9.69872 12.5678Z"
            fill="#69C9D0"
          />
          <path
            d="M18.4758 4.04056H15.6271V18.5389C15.6271 19.0485 15.6271 19.54 15.4505 20.031C15.1628 20.8146 14.5508 21.5222 13.7351 21.8362C12.5107 22.3076 11.5535 22.2553 10.4116 21.5322C10.1282 21.3451 9.87889 21.1145 9.67383 20.8496C10.6467 21.347 11.5174 21.3383 12.5961 20.9233C13.4113 20.6093 14.0243 19.9017 14.311 19.1177C14.4905 18.6281 14.4881 18.1352 14.4881 17.626V3.125H18.4217C18.4217 3.125 18.3775 3.4854 18.4758 4.04056ZM23.8627 8.36716V9.17397C23.4009 9.06855 22.9533 8.91266 22.5286 8.70936C21.7058 8.31574 21.0648 7.67458 20.9395 7.54489C21.0849 7.63641 21.2358 7.71968 21.3915 7.79426C22.3918 8.27297 23.377 8.41585 23.8627 8.36716Z"
            fill="#69C9D0"
          />
        </svg>
      );
    case INSTAGRAM:
      return (
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="2.5" width="28" height="28" rx="6" fill="url(#paint0_radial_1994_61305)" />
          <rect x="2" y="2.5" width="28" height="28" rx="6" fill="url(#paint1_radial_1994_61305)" />
          <rect x="2" y="2.5" width="28" height="28" rx="6" fill="url(#paint2_radial_1994_61305)" />
          <path
            d="M23 11C23 11.8284 22.3284 12.5 21.5 12.5C20.6716 12.5 20 11.8284 20 11C20 10.1716 20.6716 9.5 21.5 9.5C22.3284 9.5 23 10.1716 23 11Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 21.5C18.7614 21.5 21 19.2614 21 16.5C21 13.7386 18.7614 11.5 16 11.5C13.2386 11.5 11 13.7386 11 16.5C11 19.2614 13.2386 21.5 16 21.5ZM16 19.5C17.6569 19.5 19 18.1569 19 16.5C19 14.8431 17.6569 13.5 16 13.5C14.3431 13.5 13 14.8431 13 16.5C13 18.1569 14.3431 19.5 16 19.5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 16.1C6 12.7397 6 11.0595 6.65396 9.77606C7.2292 8.64708 8.14708 7.7292 9.27606 7.15396C10.5595 6.5 12.2397 6.5 15.6 6.5H16.4C19.7603 6.5 21.4405 6.5 22.7239 7.15396C23.8529 7.7292 24.7708 8.64708 25.346 9.77606C26 11.0595 26 12.7397 26 16.1V16.9C26 20.2603 26 21.9405 25.346 23.2239C24.7708 24.3529 23.8529 25.2708 22.7239 25.846C21.4405 26.5 19.7603 26.5 16.4 26.5H15.6C12.2397 26.5 10.5595 26.5 9.27606 25.846C8.14708 25.2708 7.2292 24.3529 6.65396 23.2239C6 21.9405 6 20.2603 6 16.9V16.1ZM15.6 8.5H16.4C18.1132 8.5 19.2777 8.50156 20.1779 8.5751C21.0548 8.64674 21.5032 8.77659 21.816 8.93597C22.5686 9.31947 23.1805 9.93139 23.564 10.684C23.7234 10.9968 23.8533 11.4452 23.9249 12.3221C23.9984 13.2223 24 14.3868 24 16.1V16.9C24 18.6132 23.9984 19.7777 23.9249 20.6779C23.8533 21.5548 23.7234 22.0032 23.564 22.316C23.1805 23.0686 22.5686 23.6805 21.816 24.064C21.5032 24.2234 21.0548 24.3533 20.1779 24.4249C19.2777 24.4984 18.1132 24.5 16.4 24.5H15.6C13.8868 24.5 12.7223 24.4984 11.8221 24.4249C10.9452 24.3533 10.4968 24.2234 10.184 24.064C9.43139 23.6805 8.81947 23.0686 8.43597 22.316C8.27659 22.0032 8.14674 21.5548 8.0751 20.6779C8.00156 19.7777 8 18.6132 8 16.9V16.1C8 14.3868 8.00156 13.2223 8.0751 12.3221C8.14674 11.4452 8.27659 10.9968 8.43597 10.684C8.81947 9.93139 9.43139 9.31947 10.184 8.93597C10.4968 8.77659 10.9452 8.64674 11.8221 8.5751C12.7223 8.50156 13.8868 8.5 15.6 8.5Z"
            fill="white"
          />
          <defs>
            <radialGradient
              id="paint0_radial_1994_61305"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12 23.5) rotate(-55.3758) scale(25.5196)"
            >
              <stop stop-color="#B13589" />
              <stop offset="0.79309" stop-color="#C62F94" />
              <stop offset="1" stop-color="#8A3AC8" />
            </radialGradient>
            <radialGradient
              id="paint1_radial_1994_61305"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(11 31.5) rotate(-65.1363) scale(22.5942)"
            >
              <stop stop-color="#E0E8B7" />
              <stop offset="0.444662" stop-color="#FB8A2E" />
              <stop offset="0.71474" stop-color="#E2425C" />
              <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint2_radial_1994_61305"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(0.500002 3.5) rotate(-8.1301) scale(38.8909 8.31836)"
            >
              <stop offset="0.156701" stop-color="#406ADC" />
              <stop offset="0.467799" stop-color="#6A45BE" />
              <stop offset="1" stop-color="#6A45BE" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      );
    case SNAPCHAT:
      return (
        <svg
          width="32px"
          height="32px"
          viewBox="0 0 1.28 1.28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            cx="16"
            cy="16"
            r="14"
            fill="#FFFA37"
            d="M1.2 0.64A0.56 0.56 0 0 1 0.64 1.2A0.56 0.56 0 0 1 0.08 0.64A0.56 0.56 0 0 1 1.2 0.64z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.841 0.327C0.802 0.279 0.739 0.24 0.64 0.24c-0.084 0.001 -0.252 0.047 -0.252 0.227 0 0.026 0.002 0.061 0.004 0.087a0.08 0.08 0 0 1 -0.009 -0.004l-0.001 0c-0.007 -0.004 -0.019 -0.009 -0.034 -0.009 -0.016 0 -0.031 0.006 -0.042 0.015 -0.011 0.009 -0.021 0.023 -0.021 0.04 0 0.021 0.012 0.035 0.026 0.044 0.012 0.008 0.028 0.013 0.04 0.017l0.001 0c0.013 0.004 0.023 0.008 0.03 0.012 0.005 0.003 0.006 0.005 0.006 0.007l-0.001 0.002q-0.001 0.003 -0.004 0.008a0.24 0.24 0 0 1 -0.014 0.024c-0.012 0.018 -0.027 0.036 -0.038 0.047a0.24 0.24 0 0 1 -0.047 0.034c-0.009 0.005 -0.018 0.009 -0.026 0.012a0.06 0.06 0 0 1 -0.018 0.004 0.028 0.028 0 0 0 -0.007 0.001q-0.002 0.001 -0.005 0.002c-0.003 0.001 -0.007 0.003 -0.011 0.006 -0.007 0.005 -0.017 0.015 -0.017 0.03 0 0.008 0.002 0.015 0.005 0.021 0.003 0.005 0.007 0.009 0.009 0.011l0 0 0.001 0.001c0.012 0.013 0.031 0.021 0.05 0.027 0.016 0.005 0.034 0.009 0.052 0.011l0.001 0.004 0 0c0.001 0.005 0.003 0.012 0.005 0.019 0.002 0.006 0.006 0.015 0.013 0.021 0.01 0.008 0.022 0.009 0.031 0.009 0.009 0 0.019 -0.001 0.029 -0.002l0.001 0a0.36 0.36 0 0 1 0.043 -0.003c0.027 0 0.045 0.011 0.072 0.03l0 0c0.01 0.006 0.02 0.014 0.032 0.021 0.04 0.024 0.073 0.024 0.092 0.024h0.007c0.019 0 0.052 0 0.093 -0.024 0.012 -0.007 0.023 -0.014 0.032 -0.021l0 0c0.027 -0.019 0.045 -0.03 0.072 -0.03 0.015 0 0.029 0.002 0.043 0.003l0.001 0c0.01 0.001 0.02 0.002 0.029 0.002 0.008 0 0.021 -0.001 0.031 -0.009 0.008 -0.006 0.011 -0.015 0.013 -0.021 0.002 -0.006 0.004 -0.013 0.005 -0.019l0 0 0.001 -0.004a0.304 0.304 0 0 0 0.052 -0.011c0.019 -0.006 0.038 -0.015 0.05 -0.027l0.001 -0.001 0 0c0.002 -0.002 0.006 -0.006 0.009 -0.011 0.003 -0.006 0.005 -0.013 0.005 -0.021 0 -0.016 -0.01 -0.025 -0.017 -0.03a0.052 0.052 0 0 0 -0.016 -0.007 0.028 0.028 0 0 0 -0.007 -0.001c-0.004 0 -0.01 -0.001 -0.018 -0.004a0.2 0.2 0 0 1 -0.026 -0.012 0.24 0.24 0 0 1 -0.047 -0.034c-0.011 -0.011 -0.026 -0.029 -0.038 -0.047a0.24 0.24 0 0 1 -0.014 -0.024 0.08 0.08 0 0 1 -0.004 -0.01c0 -0.002 0.001 -0.004 0.006 -0.007 0.007 -0.004 0.016 -0.007 0.03 -0.012l0.001 0c0.012 -0.004 0.028 -0.009 0.04 -0.017 0.014 -0.009 0.026 -0.023 0.026 -0.044 0 -0.017 -0.01 -0.031 -0.021 -0.04a0.068 0.068 0 0 0 -0.042 -0.015c-0.016 0 -0.027 0.005 -0.034 0.009l-0.001 0c-0.004 0.002 -0.007 0.003 -0.009 0.004 0.002 -0.026 0.004 -0.061 0.004 -0.087 0 -0.036 -0.013 -0.092 -0.051 -0.14m-0.37 0.023c-0.032 0.04 -0.043 0.088 -0.043 0.116 0 0.026 0.002 0.063 0.004 0.089a0.035 0.035 0 0 1 -0.009 0.027c-0.008 0.008 -0.018 0.011 -0.027 0.011 -0.013 0 -0.024 -0.005 -0.03 -0.008l-0.001 0c-0.007 -0.004 -0.011 -0.005 -0.017 -0.005a0.028 0.028 0 0 0 -0.016 0.006c-0.005 0.004 -0.007 0.008 -0.007 0.01 0 0.005 0.002 0.008 0.008 0.012 0.007 0.005 0.018 0.008 0.032 0.013l0.001 0c0.012 0.004 0.026 0.008 0.037 0.016 0.013 0.008 0.024 0.021 0.024 0.04 0 0.005 -0.001 0.01 -0.003 0.014a0.12 0.12 0 0 1 -0.006 0.013c-0.004 0.009 -0.01 0.018 -0.017 0.028 -0.013 0.019 -0.029 0.04 -0.043 0.053 -0.014 0.013 -0.035 0.028 -0.056 0.04 -0.011 0.006 -0.022 0.011 -0.032 0.015a0.104 0.104 0 0 1 -0.03 0.007 0.016 0.016 0 0 0 -0.002 0.001l0 0 0 0.001 0 0.001c0 0.001 0.001 0.001 0.003 0.004l0.001 0.001c0.004 0.005 0.015 0.011 0.033 0.017 0.016 0.005 0.036 0.009 0.055 0.011a0.024 0.024 0 0 1 0.017 0.01c0.002 0.003 0.004 0.007 0.004 0.009 0.002 0.004 0.003 0.01 0.004 0.014l0 0.001c0.001 0.006 0.002 0.011 0.004 0.015a0.04 0.04 0 0 0 0.001 0.003 0.04 0.04 0 0 0 0.004 0c0.008 0 0.017 -0.001 0.025 -0.002 0.013 -0.002 0.03 -0.004 0.048 -0.004 0.041 0 0.068 0.018 0.094 0.036l0.001 0.001c0.01 0.007 0.019 0.013 0.03 0.02 0.031 0.018 0.054 0.018 0.071 0.018h0.007c0.017 0 0.041 0 0.072 -0.018 0.011 -0.006 0.021 -0.013 0.03 -0.02l0.001 -0.001c0.026 -0.018 0.053 -0.036 0.094 -0.036 0.018 0 0.034 0.002 0.048 0.004l0 0c0.011 0.001 0.019 0.002 0.025 0.002a0.04 0.04 0 0 0 0.004 0 0.04 0.04 0 0 0 0.001 -0.003c0.001 -0.004 0.002 -0.009 0.004 -0.015l0 -0.001c0.001 -0.004 0.002 -0.01 0.004 -0.014a0.036 0.036 0 0 1 0.004 -0.009 0.024 0.024 0 0 1 0.017 -0.01c0.018 -0.002 0.038 -0.006 0.055 -0.011 0.017 -0.006 0.028 -0.012 0.033 -0.017l0.001 -0.001a0.024 0.024 0 0 0 0.003 -0.004l0 -0.001 0 -0.001 0 0a0.012 0.012 0 0 0 -0.002 -0.001 0.104 0.104 0 0 1 -0.03 -0.007 0.24 0.24 0 0 1 -0.032 -0.015c-0.021 -0.012 -0.042 -0.027 -0.056 -0.04 -0.014 -0.013 -0.03 -0.034 -0.043 -0.053a0.28 0.28 0 0 1 -0.017 -0.028 0.12 0.12 0 0 1 -0.006 -0.013 0.04 0.04 0 0 1 -0.003 -0.014c0 -0.02 0.012 -0.032 0.024 -0.04 0.011 -0.007 0.026 -0.012 0.037 -0.016l0.001 0c0.014 -0.005 0.025 -0.008 0.032 -0.013 0.006 -0.004 0.008 -0.007 0.008 -0.012 0 -0.002 -0.001 -0.006 -0.006 -0.01a0.028 0.028 0 0 0 -0.016 -0.006c-0.006 0 -0.009 0.002 -0.017 0.005l-0.001 0c-0.007 0.003 -0.017 0.008 -0.03 0.008 -0.009 0 -0.02 -0.003 -0.027 -0.011a0.035 0.035 0 0 1 -0.009 -0.027c0.002 -0.026 0.004 -0.063 0.004 -0.089 0 -0.028 -0.011 -0.076 -0.043 -0.116 -0.031 -0.039 -0.083 -0.072 -0.169 -0.072 -0.086 0 -0.138 0.033 -0.169 0.072"
            fill="#000000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.471 0.351c-0.032 0.04 -0.043 0.088 -0.043 0.116 0 0.026 0.002 0.063 0.004 0.089a0.035 0.035 0 0 1 -0.009 0.027c-0.008 0.008 -0.018 0.011 -0.027 0.011 -0.013 0 -0.024 -0.005 -0.03 -0.008l-0.001 0c-0.007 -0.004 -0.011 -0.005 -0.017 -0.005a0.028 0.028 0 0 0 -0.016 0.006c-0.005 0.004 -0.006 0.008 -0.006 0.01 0 0.005 0.002 0.008 0.008 0.012 0.007 0.005 0.018 0.008 0.032 0.013l0.001 0c0.012 0.004 0.026 0.008 0.037 0.016 0.013 0.008 0.024 0.021 0.024 0.04 0 0.005 -0.001 0.01 -0.003 0.014a0.12 0.12 0 0 1 -0.006 0.013c-0.004 0.009 -0.01 0.018 -0.017 0.028 -0.013 0.019 -0.029 0.04 -0.043 0.053 -0.014 0.013 -0.035 0.028 -0.056 0.04 -0.011 0.006 -0.022 0.011 -0.032 0.015a0.104 0.104 0 0 1 -0.03 0.007 0.012 0.012 0 0 0 -0.002 0.001l0 0q0 0 0 0.001l0 0.001c0 0.001 0.001 0.001 0.003 0.004l0.001 0.001c0.004 0.005 0.015 0.011 0.033 0.017 0.017 0.005 0.036 0.009 0.055 0.011a0.024 0.024 0 0 1 0.017 0.01c0.002 0.003 0.004 0.007 0.004 0.009 0.002 0.004 0.003 0.01 0.004 0.014l0 0.001c0.001 0.006 0.002 0.011 0.004 0.015a0.04 0.04 0 0 0 0.001 0.003 0.04 0.04 0 0 0 0.004 0c0.008 0 0.017 -0.001 0.025 -0.002 0.013 -0.002 0.03 -0.004 0.048 -0.004 0.041 0 0.068 0.018 0.094 0.036l0.001 0.001c0.01 0.007 0.019 0.013 0.03 0.02 0.031 0.018 0.054 0.018 0.071 0.018h0.007c0.017 0 0.041 0 0.072 -0.018 0.011 -0.006 0.021 -0.013 0.03 -0.02l0.001 -0.001c0.026 -0.018 0.053 -0.036 0.094 -0.036 0.018 0 0.034 0.002 0.048 0.004l0 0c0.011 0.001 0.019 0.002 0.025 0.002a0.04 0.04 0 0 0 0.004 0 0.04 0.04 0 0 0 0.001 -0.003c0.001 -0.004 0.002 -0.009 0.004 -0.015l0 -0.001c0.001 -0.004 0.002 -0.01 0.004 -0.014a0.036 0.036 0 0 1 0.004 -0.009 0.024 0.024 0 0 1 0.017 -0.01c0.019 -0.002 0.038 -0.006 0.055 -0.011 0.017 -0.006 0.028 -0.012 0.033 -0.017l0.001 -0.001a0.024 0.024 0 0 0 0.003 -0.004l0 -0.001 0 -0.001 0 0a0.012 0.012 0 0 0 -0.002 -0.001 0.104 0.104 0 0 1 -0.03 -0.007 0.228 0.228 0 0 1 -0.032 -0.015c-0.021 -0.012 -0.042 -0.027 -0.056 -0.04 -0.014 -0.013 -0.03 -0.034 -0.043 -0.053a0.28 0.28 0 0 1 -0.017 -0.028 0.12 0.12 0 0 1 -0.006 -0.013 0.04 0.04 0 0 1 -0.003 -0.014c0 -0.02 0.012 -0.032 0.024 -0.04 0.011 -0.007 0.026 -0.012 0.037 -0.016l0.001 0c0.014 -0.005 0.025 -0.008 0.032 -0.013 0.006 -0.004 0.008 -0.007 0.008 -0.012 0 -0.002 -0.001 -0.006 -0.006 -0.01a0.028 0.028 0 0 0 -0.016 -0.006c-0.006 0 -0.01 0.002 -0.017 0.005l-0.001 0c-0.007 0.003 -0.017 0.008 -0.03 0.008 -0.009 0 -0.02 -0.003 -0.027 -0.011a0.035 0.035 0 0 1 -0.009 -0.027 1.4 1.4 0 0 0 0.004 -0.089c0 -0.028 -0.011 -0.076 -0.043 -0.116 -0.031 -0.039 -0.083 -0.072 -0.169 -0.072s-0.138 0.033 -0.169 0.072"
            fill="white"
          />
        </svg>
      );
    case HEART:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="10" fill="white" stroke="#EFEFF4" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 16C20.5035 9.85208 14.099 4.69575 11 8.06719C7.90104 4.69575 1.49654 9.85208 11 16Z"
            fill="#C8C7CC"
          />
        </svg>
      );
    case STAR:
      return (
        <svg
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.03147 6.08549L2.78755 10L5.96527 7.42753L9.33265 9.79339L9.31928 9.7545L9.35858 9.78177L8.04977 6.04285L11.0247 4.03064L7.34182 4.00344L5.96527 0L4.69929 3.98392L0.962891 3.95632L4.03147 6.08549Z"
            fill="#FF9500"
          />
        </svg>
      );
    case EMPTYSTAR:
      return (
        <svg
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.03147 6.08549L2.78755 10L5.96527 7.42753L9.33265 9.79339L9.31928 9.7545L9.35858 9.78177L8.04977 6.04285L11.0247 4.03064L7.34182 4.00344L5.96527 0L4.69929 3.98392L0.962891 3.95632L4.03147 6.08549Z"
            fill="#8A8A8F"
          />
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

BrandingIconCard.defaultProps = {
  className: null,
  rootClassName: null,
  type: 'default',
};

BrandingIconCard.propTypes = {
  className: string,
  rootClassName: string,
  type: string,
};

export default BrandingIconCard;
